// ═══════════════════════════════════════════════════════════ PDF
// Generador de PDF sin librerías, hermano del app/pdfmini.py de la versión
// de servidor. Aquí es más simple: cada foto pasa por un canvas y sale JPEG,
// así que todas las imágenes se incrustan igual (DCTDecode) y no hace falta
// comprimir nada.

var PDF = (function () {
  "use strict";

  var A4 = [595.28, 841.89];

  // Anchos oficiales de Helvetica, en milésimas de punto.
  var REGULAR = {
    " ": 278, "!": 278, '"': 355, "#": 556, "$": 556, "%": 889, "&": 667, "'": 191,
    "(": 333, ")": 333, "*": 389, "+": 584, ",": 278, "-": 333, ".": 278, "/": 278,
    ":": 278, ";": 278, "<": 584, "=": 584, ">": 584, "?": 556, "@": 1015,
    A: 667, B: 667, C: 722, D: 722, E: 667, F: 611, G: 778, H: 722, I: 278, J: 500,
    K: 667, L: 556, M: 833, N: 722, O: 778, P: 667, Q: 778, R: 722, S: 667, T: 611,
    U: 722, V: 667, W: 944, X: 667, Y: 667, Z: 611,
    "[": 278, "\\": 278, "]": 278, "^": 469, _: 556, "`": 333,
    a: 556, b: 556, c: 500, d: 556, e: 556, f: 278, g: 556, h: 556, i: 222, j: 222,
    k: 500, l: 222, m: 833, n: 556, o: 556, p: 556, q: 556, r: 333, s: 500, t: 278,
    u: 556, v: 500, w: 722, x: 500, y: 500, z: 500,
    "{": 334, "|": 260, "}": 334, "~": 584
  };
  var BOLD = {
    " ": 278, "!": 333, '"': 474, "#": 556, "$": 556, "%": 889, "&": 722, "'": 238,
    "(": 333, ")": 333, "*": 389, "+": 584, ",": 278, "-": 333, ".": 278, "/": 278,
    ":": 333, ";": 333, "<": 584, "=": 584, ">": 584, "?": 611, "@": 975,
    A: 722, B: 722, C: 722, D: 722, E: 667, F: 611, G: 778, H: 722, I: 278, J: 556,
    K: 722, L: 611, M: 833, N: 722, O: 778, P: 667, Q: 778, R: 722, S: 667, T: 611,
    U: 722, V: 667, W: 944, X: 667, Y: 667, Z: 611,
    "[": 333, "\\": 278, "]": 333, "^": 584, _: 556, "`": 333,
    a: 556, b: 611, c: 556, d: 611, e: 556, f: 333, g: 611, h: 611, i: 278, j: 278,
    k: 556, l: 278, m: 889, n: 611, o: 611, p: 611, q: 611, r: 389, s: 556, t: 333,
    u: 611, v: 556, w: 778, x: 556, y: 556, z: 500,
    "{": 389, "|": 280, "}": 389, "~": 584
  };
  "0123456789".split("").forEach(function (d) { REGULAR[d] = 556; BOLD[d] = 556; });

  // Las acentuadas miden lo mismo que su letra base.
  var BASE = {
    "á": "a", "à": "a", "ä": "a", "â": "a", "ã": "a", "å": "a",
    "é": "e", "è": "e", "ë": "e", "ê": "e", "í": "i", "ì": "i", "ï": "i", "î": "i",
    "ó": "o", "ò": "o", "ö": "o", "ô": "o", "õ": "o", "ú": "u", "ù": "u", "ü": "u",
    "û": "u", "ñ": "n", "ç": "c", "ý": "y",
    "Á": "A", "À": "A", "Ä": "A", "Â": "A", "Ã": "A", "Å": "A", "É": "E", "È": "E",
    "Ë": "E", "Ê": "E", "Í": "I", "Ì": "I", "Ï": "I", "Î": "I", "Ó": "O", "Ò": "O",
    "Ö": "O", "Ô": "O", "Õ": "O", "Ú": "U", "Ù": "U", "Ü": "U", "Û": "U",
    "Ñ": "N", "Ç": "C",
    "¿": "?", "¡": "!", "·": ".", "°": "o", "º": "o", "ª": "a", "«": "<", "»": ">",
    "–": "-", "—": "M", "…": "...", "€": "$", "“": '"', "”": '"', "‘": "'", "’": "'"
  };

  // Caracteres de Windows-1252 que no coinciden con Unicode (rango 0x80-0x9F).
  var CP1252 = {
    0x20AC: 0x80, 0x201A: 0x82, 0x0192: 0x83, 0x201E: 0x84, 0x2026: 0x85,
    0x2020: 0x86, 0x2021: 0x87, 0x02C6: 0x88, 0x2030: 0x89, 0x0160: 0x8A,
    0x2039: 0x8B, 0x0152: 0x8C, 0x017D: 0x8E, 0x2018: 0x91, 0x2019: 0x92,
    0x201C: 0x93, 0x201D: 0x94, 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97,
    0x02DC: 0x98, 0x2122: 0x99, 0x0161: 0x9A, 0x203A: 0x9B, 0x0153: 0x9C,
    0x017E: 0x9E, 0x0178: 0x9F
  };

  function anchoTexto(texto, tamano, negrita) {
    var tabla = negrita ? BOLD : REGULAR;
    var total = 0;
    texto = String(texto == null ? "" : texto);
    for (var i = 0; i < texto.length; i++) {
      var caracter = texto[i];
      var ancho = tabla[caracter];
      if (ancho === undefined) {
        var base = BASE[caracter] || "o";
        ancho = 0;
        for (var j = 0; j < base.length; j++) ancho += tabla[base[j]] || 556;
      }
      total += ancho;
    }
    return (total * tamano) / 1000;
  }

  function recortar(texto, tamano, limite, negrita) {
    texto = String(texto == null ? "" : texto);
    if (anchoTexto(texto, tamano, negrita) <= limite) return texto;
    var cola = anchoTexto("…", tamano, negrita);
    var corte = "";
    for (var i = 0; i < texto.length; i++) {
      if (anchoTexto(corte + texto[i], tamano, negrita) + cola > limite) break;
      corte += texto[i];
    }
    return corte.replace(/\s+$/, "") + "…";
  }

  function partir(texto, tamano, limite, negrita, maximo) {
    maximo = maximo || 2;
    var palabras = String(texto == null ? "" : texto).split(/\s+/).filter(Boolean);
    if (!palabras.length) return [""];
    var lineas = [];
    var actual = "";
    var i = 0;
    while (i < palabras.length) {
      var prueba = (actual ? actual + " " : "") + palabras[i];
      if (actual && anchoTexto(prueba, tamano, negrita) > limite) {
        lineas.push(actual);
        actual = "";
        if (lineas.length === maximo) break;
        continue;
      }
      actual = prueba;
      i++;
    }
    if (lineas.length < maximo && actual) { lineas.push(actual); actual = ""; }
    if (!lineas.length) lineas = [""];
    var resto = palabras.slice(i).join(" ");
    if (resto) {
      lineas[lineas.length - 1] = recortar((lineas[lineas.length - 1] + " " + resto).trim(),
        tamano, limite, negrita);
    }
    return lineas;
  }

  // ─── bytes ──────────────────────────────────────────────────────────

  function bytesDeTexto(texto) {
    var salida = [];
    texto = String(texto == null ? "" : texto);
    for (var i = 0; i < texto.length; i++) {
      var codigo = texto.charCodeAt(i);
      if (codigo < 256) salida.push(codigo);
      else if (CP1252[codigo] !== undefined) salida.push(CP1252[codigo]);
      else salida.push(63);   // "?"
    }
    return salida;
  }

  function escapar(texto) {
    var crudo = bytesDeTexto(texto);
    var salida = [];
    for (var i = 0; i < crudo.length; i++) {
      if (crudo[i] === 0x5C || crudo[i] === 0x28 || crudo[i] === 0x29) salida.push(0x5C);
      salida.push(crudo[i]);
    }
    return salida;
  }

  function color(rgb) {
    return rgb.map(function (v) { return (v / 255).toFixed(3); }).join(" ");
  }

  // ─── página ─────────────────────────────────────────────────────────

  function Pagina(documento) {
    this.doc = documento;
    this.partes = [];
    this.imagenes = {};
    this.enlaces = [];
    this.campos = [];
  }

  Pagina.prototype.color = function (rgb, trazo) {
    this.partes.push(color(rgb) + " " + (trazo ? "RG" : "rg"));
  };

  Pagina.prototype.camino = function (x, y, ancho, alto, radio) {
    if (!radio) { this.partes.push(f(x) + " " + f(y) + " " + f(ancho) + " " + f(alto) + " re"); return; }
    var r = Math.min(radio, ancho / 2, alto / 2);
    var k = r * 0.5523;
    var der = x + ancho, arr = y + alto;
    this.partes.push(f(x + r) + " " + f(y) + " m");
    this.partes.push(f(der - r) + " " + f(y) + " l");
    this.partes.push(f(der - r + k) + " " + f(y) + " " + f(der) + " " + f(y + r - k) + " " + f(der) + " " + f(y + r) + " c");
    this.partes.push(f(der) + " " + f(arr - r) + " l");
    this.partes.push(f(der) + " " + f(arr - r + k) + " " + f(der - r + k) + " " + f(arr) + " " + f(der - r) + " " + f(arr) + " c");
    this.partes.push(f(x + r) + " " + f(arr) + " l");
    this.partes.push(f(x + r - k) + " " + f(arr) + " " + f(x) + " " + f(arr - r + k) + " " + f(x) + " " + f(arr - r) + " c");
    this.partes.push(f(x) + " " + f(y + r) + " l");
    this.partes.push(f(x) + " " + f(y + r - k) + " " + f(x + r - k) + " " + f(y) + " " + f(x + r) + " " + f(y) + " c");
    this.partes.push("h");
  };

  function f(n) { return (Math.round(n * 100) / 100).toString(); }

  Pagina.prototype.rect = function (x, y, ancho, alto, opciones) {
    opciones = opciones || {};
    if (opciones.relleno) this.color(opciones.relleno);
    if (opciones.borde) { this.color(opciones.borde, true); this.partes.push((opciones.linea || 0.7) + " w"); }
    this.camino(x, y, ancho, alto, opciones.radio || 0);
    if (opciones.relleno && opciones.borde) this.partes.push("B");
    else if (opciones.relleno) this.partes.push("f");
    else if (opciones.borde) this.partes.push("S");
  };

  Pagina.prototype.linea = function (x1, y1, x2, y2, rgb, grosor) {
    this.color(rgb || [200, 205, 215], true);
    this.partes.push((grosor || 0.7) + " w " + f(x1) + " " + f(y1) + " m " + f(x2) + " " + f(y2) + " l S");
  };

  Pagina.prototype.texto = function (x, y, contenido, opciones) {
    opciones = opciones || {};
    contenido = String(contenido == null ? "" : contenido);
    if (!contenido.trim()) return;
    var tamano = opciones.tamano || 10;
    var negrita = !!opciones.negrita;
    if (opciones.alinear === "centro") x += (opciones.ancho - anchoTexto(contenido, tamano, negrita)) / 2;
    else if (opciones.alinear === "derecha") x += opciones.ancho - anchoTexto(contenido, tamano, negrita);
    this.color(opciones.color || [16, 24, 40]);
    var cuerpo = escapar(contenido).map(function (b) { return String.fromCharCode(b); }).join("");
    this.partes.push("BT /" + (negrita ? "F2" : "F1") + " " + tamano + " Tf 1 0 0 1 " +
      f(x) + " " + f(y) + " Tm (" + cuerpo + ") Tj ET");
  };

  /** La foto ya viene como JPEG (bytes) con sus medidas: {datos, ancho, alto}. */
  Pagina.prototype.imagen = function (clave, foto, x, y, cajaAncho, cajaAlto) {
    if (!foto || !foto.datos) return false;
    var nombre = this.doc.registrarImagen(clave, foto);
    var registro = this.doc.imagenes[clave];
    var escala = Math.min(cajaAncho / registro.ancho, cajaAlto / registro.alto);
    var w = registro.ancho * escala, h = registro.alto * escala;
    this.imagenes[nombre] = registro.numero;
    this.partes.push("q " + f(w) + " 0 0 " + f(h) + " " + f(x + (cajaAncho - w) / 2) + " " +
      f(y + (cajaAlto - h) / 2) + " cm /" + nombre + " Do Q");
    return true;
  };

  Pagina.prototype.enlace = function (x, y, ancho, alto, url) {
    if (url) this.enlaces.push([x, y, x + ancho, y + alto, url]);
  };

  Pagina.prototype.campo = function (nombre, x, y, ancho, alto, opciones) {
    opciones = opciones || {};
    this.campos.push({
      nombre: nombre, rect: [x, y, x + ancho, y + alto],
      tamano: opciones.tamano || 10, fondo: opciones.fondo, borde: opciones.borde
    });
  };

  // ─── documento ──────────────────────────────────────────────────────

  function Documento(tamano) {
    this.ancho = (tamano || A4)[0];
    this.alto = (tamano || A4)[1];
    this.paginas = [];
    this.imagenes = {};
    this.objetos = [];
    this.fuenteNormal = this.reservar();
    this.fuenteNegrita = this.reservar();
    this.objetos[this.fuenteNormal - 1] =
      "<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>";
    this.objetos[this.fuenteNegrita - 1] =
      "<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>";
  }

  Documento.prototype.reservar = function () {
    this.objetos.push("");
    return this.objetos.length;
  };

  Documento.prototype.nuevaPagina = function () {
    var pagina = new Pagina(this);
    this.paginas.push(pagina);
    return pagina;
  };

  Documento.prototype.registrarImagen = function (clave, foto) {
    if (this.imagenes[clave]) return "Im" + this.imagenes[clave].numero;
    var numero = this.reservar();
    this.objetos[numero - 1] = {
      cabecera: "<< /Type /XObject /Subtype /Image /Width " + foto.ancho + " /Height " + foto.alto +
        " /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length " +
        foto.datos.length + " >>",
      datos: foto.datos
    };
    this.imagenes[clave] = { numero: numero, ancho: foto.ancho, alto: foto.alto };
    return "Im" + numero;
  };

  Documento.prototype.construir = function () {
    var paginasNumero = this.reservar();
    var numeros = [];
    var campos = [];
    var doc = this;

    this.paginas.forEach(function (pagina) {
      var cuerpo = pagina.partes.join("\n");
      var contenido = doc.reservar();
      doc.objetos[contenido - 1] = { cabecera: "<< /Length " + bytesDeTexto(cuerpo).length + " >>",
        datos: bytesDeTexto(cuerpo) };

      var numero = doc.reservar();      // la página se reserva antes: las casillas la citan
      var anotaciones = [];

      pagina.enlaces.forEach(function (e) {
        var anotacion = doc.reservar();
        doc.objetos[anotacion - 1] = "<< /Type /Annot /Subtype /Link /Border [0 0 0] /Rect [" +
          f(e[0]) + " " + f(e[1]) + " " + f(e[2]) + " " + f(e[3]) + "] /A << /S /URI /URI (" +
          escapar(e[4]).map(function (b) { return String.fromCharCode(b); }).join("") + ") >> >>";
        anotaciones.push(anotacion);
      });

      pagina.campos.forEach(function (campo) {
        var widget = doc.reservar();
        var marcas = [];
        if (campo.fondo) marcas.push("/BG [" + color(campo.fondo) + "]");
        if (campo.borde) marcas.push("/BC [" + color(campo.borde) + "]");
        doc.objetos[widget - 1] = "<< /Type /Annot /Subtype /Widget /FT /Tx /F 4 /P " + numero +
          " 0 R /T (" + campo.nombre + ") /V () /Q 1 /Rect [" + campo.rect.map(f).join(" ") +
          "] /DA (/Helv " + campo.tamano + " Tf 0 g)" +
          (marcas.length ? " /MK << " + marcas.join(" ") + " >>" : "") + " >>";
        anotaciones.push(widget);
        campos.push(widget);
      });

      var recursos = Object.keys(pagina.imagenes).map(function (nombre) {
        return "/" + nombre + " " + pagina.imagenes[nombre] + " 0 R";
      }).join(" ");
      doc.objetos[numero - 1] = "<< /Type /Page /Parent " + paginasNumero + " 0 R /MediaBox [0 0 " +
        f(doc.ancho) + " " + f(doc.alto) + "] /Resources << /Font << /F1 " + doc.fuenteNormal +
        " 0 R /F2 " + doc.fuenteNegrita + " 0 R >> /XObject << " + recursos + " >> >>" +
        (anotaciones.length ? " /Annots [" + anotaciones.map(function (n) { return n + " 0 R"; }).join(" ") + "]" : "") +
        " /Contents " + contenido + " 0 R >>";
      numeros.push(numero);
    });

    this.objetos[paginasNumero - 1] = "<< /Type /Pages /Count " + numeros.length + " /Kids [" +
      numeros.map(function (n) { return n + " 0 R"; }).join(" ") + "] >>";

    var formulario = "";
    if (campos.length) {
      formulario = " /AcroForm << /Fields [" + campos.map(function (n) { return n + " 0 R"; }).join(" ") +
        "] /NeedAppearances true /DA (/Helv 0 Tf 0 g) /DR << /Font << /Helv " +
        this.fuenteNormal + " 0 R >> >> >>";
    }
    var catalogo = this.reservar();
    this.objetos[catalogo - 1] = "<< /Type /Catalog /Pages " + paginasNumero + " 0 R" + formulario + " >>";

    // Ensamblado final
    var trozos = [];
    var largo = 0;
    function empujar(bytes) { trozos.push(bytes); largo += bytes.length; }

    empujar(bytesDeTexto("%PDF-1.4\n"));
    empujar([0x25, 0xE2, 0xE3, 0xCF, 0xD3, 0x0A]);
    var posiciones = [];
    this.objetos.forEach(function (objeto, indice) {
      posiciones.push(largo);
      empujar(bytesDeTexto((indice + 1) + " 0 obj\n"));
      if (typeof objeto === "string") {
        empujar(bytesDeTexto(objeto));
      } else {
        empujar(bytesDeTexto(objeto.cabecera + "\nstream\n"));
        empujar(objeto.datos);
        empujar(bytesDeTexto("\nendstream"));
      }
      empujar(bytesDeTexto("\nendobj\n"));
    });
    var inicio = largo;
    empujar(bytesDeTexto("xref\n0 " + (this.objetos.length + 1) + "\n0000000000 65535 f \n"));
    posiciones.forEach(function (posicion) {
      empujar(bytesDeTexto(("0000000000" + posicion).slice(-10) + " 00000 n \n"));
    });
    empujar(bytesDeTexto("trailer\n<< /Size " + (this.objetos.length + 1) + " /Root " + catalogo +
      " 0 R >>\nstartxref\n" + inicio + "\n%%EOF\n"));

    var salida = new Uint8Array(largo);
    var puesto = 0;
    trozos.forEach(function (bytes) {
      if (bytes instanceof Uint8Array) salida.set(bytes, puesto);
      else salida.set(new Uint8Array(bytes), puesto);
      puesto += bytes.length;
    });
    return salida;
  };

  return {
    A4: A4,
    Documento: Documento,
    anchoTexto: anchoTexto,
    recortar: recortar,
    partir: partir
  };
})();


// ═══════════════════════════════════════════════════════════ EXCEL
// Escribe un .xlsx sin librerías: un ZIP con varios XML dentro. Hermano del
// app/xlsxmini.py de la versión de servidor. Las entradas van sin comprimir
// (método 0), que el formato lo admite y así no dependemos de nada.

var XLSX = (function () {
  "use strict";

  // Estilos disponibles (el índice es el que se pasa en cada celda).
  var NORMAL = 0, TITULO = 1, SUBTITULO = 2, CABECERA = 3, TEXTO = 4,
      SKU = 5, PRECIO = 6, ENTERO = 7, ENLACE = 8, CASILLA = 9, TACHADO = 10;

  var EMU = 9525;

  function letra(indice) {
    var salida = "";
    var n = indice;
    for (;;) {
      salida = String.fromCharCode(65 + (n % 26)) + salida;
      n = Math.floor(n / 26) - 1;
      if (n < 0) return salida;
    }
  }

  function escaparXml(texto) {
    return String(texto == null ? "" : texto)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, "");
  }

  // ─── CRC32 y ZIP ────────────────────────────────────────────────────

  var TABLA_CRC = (function () {
    var tabla = new Uint32Array(256);
    for (var n = 0; n < 256; n++) {
      var c = n;
      for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
      tabla[n] = c >>> 0;
    }
    return tabla;
  })();

  function crc32(bytes) {
    var c = 0xFFFFFFFF;
    for (var i = 0; i < bytes.length; i++) c = TABLA_CRC[(c ^ bytes[i]) & 0xFF] ^ (c >>> 8);
    return (c ^ 0xFFFFFFFF) >>> 0;
  }

  function textoABytes(texto) {
    return new TextEncoder().encode(texto);
  }

  function zip(archivos) {
    var trozos = [];
    var central = [];
    var posicion = 0;

    function numero(valor, bytes) {
      var salida = [];
      for (var i = 0; i < bytes; i++) salida.push((valor >>> (8 * i)) & 0xFF);
      return salida;
    }

    archivos.forEach(function (archivo) {
      var nombre = textoABytes(archivo.nombre);
      var datos = archivo.datos instanceof Uint8Array ? archivo.datos : textoABytes(archivo.datos);
      var suma = crc32(datos);

      var cabecera = [].concat(
        [0x50, 0x4B, 0x03, 0x04], numero(20, 2), numero(0, 2), numero(0, 2),
        numero(0, 2), numero(0, 2),                       // hora y fecha
        numero(suma, 4), numero(datos.length, 4), numero(datos.length, 4),
        numero(nombre.length, 2), numero(0, 2)
      );
      trozos.push(new Uint8Array(cabecera), nombre, datos);
      central.push({ nombre: nombre, suma: suma, largo: datos.length, offset: posicion });
      posicion += cabecera.length + nombre.length + datos.length;
    });

    var inicioCentral = posicion;
    central.forEach(function (entrada) {
      var registro = [].concat(
        [0x50, 0x4B, 0x01, 0x02], numero(20, 2), numero(20, 2), numero(0, 2), numero(0, 2),
        numero(0, 2), numero(0, 2), numero(entrada.suma, 4),
        numero(entrada.largo, 4), numero(entrada.largo, 4),
        numero(entrada.nombre.length, 2), numero(0, 2), numero(0, 2), numero(0, 2),
        numero(0, 2), numero(0, 4), numero(entrada.offset, 4)
      );
      trozos.push(new Uint8Array(registro), entrada.nombre);
      posicion += registro.length + entrada.nombre.length;
    });

    var fin = [].concat(
      [0x50, 0x4B, 0x05, 0x06], numero(0, 2), numero(0, 2),
      numero(central.length, 2), numero(central.length, 2),
      numero(posicion - inicioCentral, 4), numero(inicioCentral, 4), numero(0, 2)
    );
    trozos.push(new Uint8Array(fin));
    posicion += fin.length;

    var salida = new Uint8Array(posicion);
    var puesto = 0;
    trozos.forEach(function (trozo) { salida.set(trozo, puesto); puesto += trozo.length; });
    return salida;
  }

  // ─── libro ──────────────────────────────────────────────────────────

  function Libro(nombreHoja) {
    this.nombreHoja = (nombreHoja || "Catalogo").slice(0, 31) || "Catalogo";
    this.columnas = [];
    this.filas = [];        // {alto, celdas:[{valor, estilo, tipo, enlace}]}
    this.imagenes = [];     // {fila, columna, datos, ancho, alto}
    this.combinadas = [];
    this.filasFijas = 0;
    this.autofiltro = "";
  }

  Libro.prototype.anchos = function (lista) { this.columnas = lista.slice(); };

  Libro.prototype.fila = function (celdas, alto) {
    this.filas.push({ alto: alto || 0, celdas: celdas });
    return this.filas.length - 1;
  };

  Libro.prototype.imagen = function (fila, columna, datos, ancho, alto) {
    this.imagenes.push({ fila: fila, columna: columna, datos: datos, ancho: ancho, alto: alto });
  };

  Libro.prototype.combinar = function (desde, hasta) { this.combinadas.push(desde + ":" + hasta); };

  function celdaXml(referencia, celda) {
    var estilo = celda.estilo || 0;
    if (celda.valor === null || celda.valor === undefined || celda.valor === "") {
      return '<c r="' + referencia + '" s="' + estilo + '"/>';
    }
    if (celda.tipo === "n") {
      return '<c r="' + referencia + '" s="' + estilo + '"><v>' + celda.valor + "</v></c>";
    }
    return '<c r="' + referencia + '" s="' + estilo + '" t="inlineStr"><is><t xml:space="preserve">' +
      escaparXml(celda.valor) + "</t></is></c>";
  }

  Libro.prototype.hojaXml = function (enlaces) {
    var partes = ['<?xml version="1.0" encoding="UTF-8" standalone="yes"?>',
      '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"' +
      ' xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'];

    if (this.filasFijas) {
      partes.push('<sheetViews><sheetView workbookViewId="0" showGridLines="0">' +
        '<pane ySplit="' + this.filasFijas + '" topLeftCell="A' + (this.filasFijas + 1) +
        '" activePane="bottomLeft" state="frozen"/></sheetView></sheetViews>');
    } else {
      partes.push('<sheetViews><sheetView workbookViewId="0" showGridLines="0"/></sheetViews>');
    }
    partes.push('<sheetFormatPr defaultRowHeight="15"/>');

    if (this.columnas.length) {
      partes.push("<cols>" + this.columnas.map(function (ancho, i) {
        return '<col min="' + (i + 1) + '" max="' + (i + 1) + '" width="' + ancho + '" customWidth="1"/>';
      }).join("") + "</cols>");
    }

    partes.push("<sheetData>");
    this.filas.forEach(function (fila, indice) {
      var numero = indice + 1;
      var cuerpo = fila.celdas.map(function (celda, columna) {
        return celdaXml(letra(columna) + numero, celda);
      }).join("");
      partes.push('<row r="' + numero + '"' +
        (fila.alto ? ' ht="' + fila.alto + '" customHeight="1"' : "") + ">" + cuerpo + "</row>");
    });
    partes.push("</sheetData>");

    if (this.autofiltro) partes.push('<autoFilter ref="' + this.autofiltro + '"/>');
    if (this.combinadas.length) {
      partes.push('<mergeCells count="' + this.combinadas.length + '">' +
        this.combinadas.map(function (r) { return '<mergeCell ref="' + r + '"/>'; }).join("") +
        "</mergeCells>");
    }
    if (enlaces.length) {
      partes.push("<hyperlinks>" + enlaces.map(function (e) {
        return '<hyperlink ref="' + e.referencia + '" r:id="rId' + e.numero + '"/>';
      }).join("") + "</hyperlinks>");
    }
    partes.push('<pageMargins left="0.4" right="0.4" top="0.5" bottom="0.5" header="0.3" footer="0.3"/>');
    partes.push('<pageSetup orientation="landscape" fitToWidth="1" paperSize="9"/>');
    if (this.imagenes.length) partes.push('<drawing r:id="rIdDrawing"/>');
    partes.push("</worksheet>");
    return partes.join("");
  };

  Libro.prototype.dibujoXml = function () {
    var anclas = this.imagenes.map(function (imagen, indice) {
      var numero = indice + 1;
      var cx = Math.round(imagen.ancho * EMU), cy = Math.round(imagen.alto * EMU);
      return "<xdr:oneCellAnchor>" +
        "<xdr:from><xdr:col>" + imagen.columna + "</xdr:col><xdr:colOff>" + (4 * EMU) + "</xdr:colOff>" +
        "<xdr:row>" + imagen.fila + "</xdr:row><xdr:rowOff>" + (3 * EMU) + "</xdr:rowOff></xdr:from>" +
        '<xdr:ext cx="' + cx + '" cy="' + cy + '"/>' +
        "<xdr:pic><xdr:nvPicPr><xdr:cNvPr id=\"" + (numero + 1) + "\" name=\"foto" + numero +
        "\"/><xdr:cNvPicPr/></xdr:nvPicPr>" +
        '<xdr:blipFill><a:blip r:embed="rIdImg' + numero + '"/><a:stretch><a:fillRect/></a:stretch></xdr:blipFill>' +
        '<xdr:spPr><a:xfrm><a:off x="0" y="0"/><a:ext cx="' + cx + '" cy="' + cy + '"/></a:xfrm>' +
        '<a:prstGeom prst="rect"><a:avLst/></a:prstGeom></xdr:spPr>' +
        "</xdr:pic><xdr:clientData/></xdr:oneCellAnchor>";
    }).join("");
    return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
      '<xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"' +
      ' xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"' +
      ' xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">' +
      anclas + "</xdr:wsDr>";
  };

  var ESTILOS = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
    '<numFmts count="1"><numFmt numFmtId="164" formatCode="&quot;$&quot;#,##0.00"/></numFmts>' +
    '<fonts count="8">' +
    '<font><sz val="11"/><name val="Calibri"/><color rgb="FF101828"/></font>' +
    '<font><b/><sz val="20"/><name val="Calibri"/><color rgb="FF0B7E73"/></font>' +
    '<font><sz val="11"/><name val="Calibri"/><color rgb="FF6B7280"/></font>' +
    '<font><b/><sz val="11"/><name val="Calibri"/><color rgb="FFFFFFFF"/></font>' +
    '<font><b/><sz val="12"/><name val="Calibri"/><color rgb="FFD01919"/></font>' +
    '<font><u/><sz val="10"/><name val="Calibri"/><color rgb="FF1155CC"/></font>' +
    '<font><sz val="10"/><name val="Consolas"/><color rgb="FF344054"/></font>' +
    '<font><strike/><sz val="11"/><name val="Calibri"/><color rgb="FF8A94A6"/></font>' +
    "</fonts>" +
    '<fills count="4"><fill><patternFill patternType="none"/></fill>' +
    '<fill><patternFill patternType="gray125"/></fill>' +
    '<fill><patternFill patternType="solid"><fgColor rgb="FF0B7E73"/><bgColor indexed="64"/></patternFill></fill>' +
    '<fill><patternFill patternType="solid"><fgColor rgb="FFFFF8E1"/><bgColor indexed="64"/></patternFill></fill>' +
    "</fills>" +
    '<borders count="2"><border><left/><right/><top/><bottom/><diagonal/></border>' +
    '<border><left style="thin"><color rgb="FFE3E8EF"/></left>' +
    '<right style="thin"><color rgb="FFE3E8EF"/></right>' +
    '<top style="thin"><color rgb="FFE3E8EF"/></top>' +
    '<bottom style="thin"><color rgb="FFE3E8EF"/></bottom><diagonal/></border></borders>' +
    '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>' +
    '<cellXfs count="11">' +
    '<xf xfId="0" numFmtId="0" fontId="0" fillId="0" borderId="0" applyAlignment="1"><alignment vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="0" fontId="1" fillId="0" borderId="0" applyFont="1" applyAlignment="1"><alignment vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="0" fontId="2" fillId="0" borderId="0" applyFont="1" applyAlignment="1"><alignment vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="0" fontId="3" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1">' +
    '<alignment horizontal="center" vertical="center" wrapText="1"/></xf>' +
    '<xf xfId="0" numFmtId="0" fontId="0" fillId="0" borderId="1" applyBorder="1" applyAlignment="1">' +
    '<alignment vertical="center" wrapText="1"/></xf>' +
    '<xf xfId="0" numFmtId="0" fontId="6" fillId="0" borderId="1" applyFont="1" applyBorder="1" applyAlignment="1">' +
    '<alignment vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="164" fontId="4" fillId="0" borderId="1" applyFont="1" applyNumberFormat="1" applyBorder="1" applyAlignment="1">' +
    '<alignment horizontal="right" vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="1" fontId="0" fillId="0" borderId="1" applyNumberFormat="1" applyBorder="1" applyAlignment="1">' +
    '<alignment horizontal="center" vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="0" fontId="5" fillId="0" borderId="1" applyFont="1" applyBorder="1" applyAlignment="1">' +
    '<alignment horizontal="center" vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="0" fontId="0" fillId="3" borderId="1" applyFill="1" applyBorder="1" applyAlignment="1">' +
    '<alignment horizontal="center" vertical="center"/></xf>' +
    '<xf xfId="0" numFmtId="164" fontId="7" fillId="0" borderId="1" applyFont="1" applyNumberFormat="1" applyBorder="1" applyAlignment="1">' +
    '<alignment horizontal="right" vertical="center"/></xf>' +
    "</cellXfs>" +
    '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles></styleSheet>';

  Libro.prototype.construir = function () {
    var enlaces = [];
    this.filas.forEach(function (fila, indice) {
      fila.celdas.forEach(function (celda, columna) {
        if (celda.enlace) {
          enlaces.push({ referencia: letra(columna) + (indice + 1), numero: enlaces.length + 1,
            destino: celda.enlace });
        }
      });
    });

    var tipos = ['<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>',
      '<Default Extension="xml" ContentType="application/xml"/>',
      '<Default Extension="jpeg" ContentType="image/jpeg"/>',
      '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>',
      '<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>',
      '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>'];
    if (this.imagenes.length) {
      tipos.push('<Override PartName="/xl/drawings/drawing1.xml" ContentType="application/vnd.openxmlformats-officedocument.drawing+xml"/>');
    }

    var relacionesHoja = enlaces.map(function (e) {
      return '<Relationship Id="rId' + e.numero + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="' +
        escaparXml(e.destino) + '" TargetMode="External"/>';
    });
    if (this.imagenes.length) {
      relacionesHoja.push('<Relationship Id="rIdDrawing" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="../drawings/drawing1.xml"/>');
    }

    var archivos = [
      { nombre: "[Content_Types].xml", datos: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
        '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">' + tipos.join("") + "</Types>" },
      { nombre: "_rels/.rels", datos: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
        '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
        '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>' },
      { nombre: "xl/workbook.xml", datos: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
        '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"' +
        ' xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">' +
        '<sheets><sheet name="' + escaparXml(this.nombreHoja) + '" sheetId="1" r:id="rId1"/></sheets></workbook>' },
      { nombre: "xl/_rels/workbook.xml.rels", datos: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
        '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
        '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>' +
        '<Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>' },
      { nombre: "xl/styles.xml", datos: ESTILOS },
      { nombre: "xl/worksheets/sheet1.xml", datos: this.hojaXml(enlaces) }
    ];
    if (relacionesHoja.length) {
      archivos.push({ nombre: "xl/worksheets/_rels/sheet1.xml.rels",
        datos: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
          '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
          relacionesHoja.join("") + "</Relationships>" });
    }
    if (this.imagenes.length) {
      archivos.push({ nombre: "xl/drawings/drawing1.xml", datos: this.dibujoXml() });
      archivos.push({ nombre: "xl/drawings/_rels/drawing1.xml.rels",
        datos: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
          '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
          this.imagenes.map(function (_, i) {
            return '<Relationship Id="rIdImg' + (i + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="../media/imagen' + (i + 1) + '.jpeg"/>';
          }).join("") + "</Relationships>" });
      this.imagenes.forEach(function (imagen, i) {
        archivos.push({ nombre: "xl/media/imagen" + (i + 1) + ".jpeg", datos: imagen.datos });
      });
    }
    return zip(archivos);
  };

  return {
    Libro: Libro, letra: letra,
    NORMAL: NORMAL, TITULO: TITULO, SUBTITULO: SUBTITULO, CABECERA: CABECERA,
    TEXTO: TEXTO, SKU: SKU, PRECIO: PRECIO, ENTERO: ENTERO, ENLACE: ENLACE,
    CASILLA: CASILLA, TACHADO: TACHADO
  };
})();


// ═══════════════════════════════════════════════════════════ CATÁLOGO
// Arma el PDF y el Excel de una colección. Es el mismo diseño que la versión
// de servidor (app/catalogo_docs.py): portada, 9 fichas por página, casilla de
// cantidad rellenable y enlace al producto sobre la foto.

var DOCUMENTOS = (function () {
  "use strict";

  var TEAL = [11, 126, 115], TEAL_SUAVE = [230, 246, 244], ROJO = [208, 25, 25];
  var TEXTO = [16, 24, 40], SUAVE = [90, 100, 120], MUDO = [138, 148, 166];
  var BORDE = [227, 232, 239], FONDO = [248, 250, 252], BLANCO = [255, 255, 255];

  var MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio",
    "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

  var MARGEN = 36, COLUMNAS = 3, FILAS = 3, GAP = 14, ALTO_TARJETA = 224;
  var PIE = "Precios en dolares (USD), sujetos a cambio sin previo aviso.";

  var LISTAS = { normal: "Precio normal", a: "Lista A", b: "Lista B", c: "Lista C" };

  var MESES_EN = ["January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"];

  // Textos que van DENTRO del documento (PDF y Excel), por idioma. Los
  // nombres de producto y coleccion no estan aqui: llegan ya traducidos de
  // la tienda cuando la app pide /en/collections/... (ver cargarProductos).
  // Sin acentos a proposito: la fuente del PDF solo trae caracteres basicos.
  var TEXTOS = {
    es: {
      idioma: "es",
      pie: PIE,
      catalogoDe: "CATALOGO DE PRODUCTOS",
      productos: function (n) { return n + " producto" + (n === 1 ? "" : "s"); },
      preparadoPara: "PREPARADO PARA",
      preparadoParaExcel: "Preparado para: ",
      pagina: function (n, total) { return "Pagina " + n + " de " + total; },
      sinFoto: "Sin foto",
      disponible: "Disponible",
      existencia: function (n) { return "Existencia: " + n; },
      bajoPedido: "Bajo pedido",
      desde: "desde ",
      precioNormal: "precio normal",
      cantidad: "Cantidad",
      catalogo: "Catalogo",
      colFoto: "Foto",
      colReferencia: "Referencia",
      colProducto: "Producto",
      colPrecioNormal: "Precio normal",
      colPrecioMayor: "Precio al mayor",
      colPrecio: "Precio",
      colExistencia: "Existencia",
      colCantidad: "Cantidad a pedir",
      colEnlace: "Ver en la web",
      sinControl: "Sin control",
      verProducto: "Ver producto"
    },
    en: {
      idioma: "en",
      pie: "Prices in US dollars (USD), subject to change without notice.",
      catalogoDe: "PRODUCT CATALOG",
      productos: function (n) { return n + " product" + (n === 1 ? "" : "s"); },
      preparadoPara: "PREPARED FOR",
      preparadoParaExcel: "Prepared for: ",
      pagina: function (n, total) { return "Page " + n + " of " + total; },
      sinFoto: "No photo",
      disponible: "Available",
      existencia: function (n) { return "In stock: " + n; },
      bajoPedido: "On request",
      desde: "from ",
      precioNormal: "regular price",
      cantidad: "Quantity",
      catalogo: "Catalog",
      colFoto: "Photo",
      colReferencia: "SKU",
      colProducto: "Product",
      colPrecioNormal: "Regular price",
      colPrecioMayor: "Wholesale price",
      colPrecio: "Price",
      colExistencia: "Stock",
      colCantidad: "Order qty",
      colEnlace: "View online",
      sinControl: "Not tracked",
      verProducto: "View product"
    }
  };

  function textos(idioma) { return TEXTOS[idioma] || TEXTOS.es; }

  function fechaLarga(idioma) {
    var hoy = new Date();
    if (idioma === "en") {
      return MESES_EN[hoy.getMonth()] + " " + hoy.getDate() + ", " + hoy.getFullYear();
    }
    return hoy.getDate() + " de " + MESES[hoy.getMonth()] + " de " + hoy.getFullYear();
  }

  function dinero(valor) {
    if (valor === null || valor === undefined) return "-";
    return "$" + Number(valor).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function etiquetaLista(lista) { return LISTAS[lista] || LISTAS.normal; }

  /** Precio a mostrar: si la lista elegida no tiene valor, se usa el normal. */
  function precioDe(producto, lista) {
    var precios = producto.precios || {};
    var valor = precios[lista];
    if (lista !== "normal" && (valor === null || valor === undefined)) {
      return { valor: precios.normal === undefined ? null : precios.normal, aproximado: true };
    }
    return { valor: valor === undefined ? null : valor, aproximado: false };
  }

  /**
   * (precio que paga, precio normal tachado, si hubo que caer al normal).
   * El normal solo se muestra cuando de verdad es mas alto: en Ofertas hay
   * productos cuyo precio de lista supera al publico, y ahi tacharlo seria
   * un autogol.
   */
  function comparacion(producto, lista) {
    var oferta = precioDe(producto, lista);
    var normal = (producto.precios || {}).normal;
    if (lista === "normal" || oferta.aproximado || oferta.valor === null ||
        normal === null || normal === undefined || normal <= oferta.valor) {
      return { valor: oferta.valor, normal: null, aproximado: oferta.aproximado };
    }
    return { valor: oferta.valor, normal: normal, aproximado: false };
  }

  // ─── fotos ──────────────────────────────────────────────────────────

  /** Pide la foto al CDN ya reducida. */
  function urlFoto(url, ancho) {
    try {
      var parsed = new URL(url, location.origin);
      parsed.searchParams.set("width", String(ancho));
      return parsed.toString();
    } catch (error) { return url; }
  }

  /**
   * Descarga la foto y la pasa por un canvas para que salga siempre JPEG.
   * Así se resuelven de una vez los PNG con transparencia (que Shopify no
   * convierte) y de paso el archivo pesa mucho menos.
   */
  async function prepararFoto(url, ancho, calidad) {
    var respuesta = await fetch(urlFoto(url, ancho), { mode: "cors" });
    if (!respuesta.ok) throw new Error("HTTP " + respuesta.status);
    var bitmap = await createImageBitmap(await respuesta.blob());
    var escala = Math.min(1, ancho / Math.max(bitmap.width, bitmap.height));
    var w = Math.max(1, Math.round(bitmap.width * escala));
    var h = Math.max(1, Math.round(bitmap.height * escala));

    var lienzo = document.createElement("canvas");
    lienzo.width = w;
    lienzo.height = h;
    var pincel = lienzo.getContext("2d");
    pincel.fillStyle = "#ffffff";          // la transparencia va sobre blanco
    pincel.fillRect(0, 0, w, h);
    pincel.drawImage(bitmap, 0, 0, w, h);
    bitmap.close && bitmap.close();

    var blob = await new Promise(function (listo) {
      lienzo.toBlob(listo, "image/jpeg", calidad || 0.82);
    });
    if (!blob) throw new Error("no se pudo convertir la foto");
    return { datos: new Uint8Array(await blob.arrayBuffer()), ancho: w, alto: h };
  }

  /** Descarga en paralelo. avance(hechas, total) para la barra de progreso. */
  async function bajarFotos(urls, ancho, calidad, avance, hilos) {
    var unicas = [];
    var vistas = {};
    urls.forEach(function (url) {
      if (url && !vistas[url]) { vistas[url] = true; unicas.push(url); }
    });
    var fotos = {};
    var siguiente = 0;
    var hechas = 0;

    async function trabajador() {
      while (siguiente < unicas.length) {
        var url = unicas[siguiente++];
        for (var intento = 0; intento < 2; intento++) {
          try {
            fotos[url] = await prepararFoto(url, ancho, calidad);
            break;
          } catch (error) {
            if (intento) break;
            await new Promise(function (r) { setTimeout(r, 400); });
          }
        }
        hechas++;
        if (avance) avance(hechas, unicas.length);
      }
    }

    var equipo = [];
    for (var i = 0; i < Math.min(hilos || 6, unicas.length); i++) equipo.push(trabajador());
    await Promise.all(equipo);
    return fotos;
  }

  // ─── PDF ────────────────────────────────────────────────────────────

  function construirPdf(datos, opciones, fotos) {
    var productos = datos.productos;
    var lista = opciones.lista || "normal";
    var empresa = (opciones.empresa || "").trim();
    var tienda = opciones.tienda || "Sirena Internacional";
    var web = (opciones.web || "").replace(/^https?:\/\//, "").replace(/\/$/, "");
    var conStock = !!opciones.existencia;
    var conEnlace = !!opciones.enlace;
    var conCasilla = !!opciones.cantidad;
    var sinPrecio = !!opciones.sinPrecio;

    var T = textos(opciones.idioma);
    var documento = new PDF.Documento(PDF.A4);
    var ancho = documento.ancho, alto = documento.alto;
    var porPagina = COLUMNAS * FILAS;
    var paginasProducto = Math.max(1, Math.ceil(productos.length / porPagina));
    var totalPaginas = paginasProducto + 1;

    portada(documento, datos, productos, fotos, {
      lista: lista, empresa: empresa, tienda: tienda, web: web, nota: (opciones.nota || "").trim(), T: T
    });

    var anchoTarjeta = (ancho - 2 * MARGEN - GAP * (COLUMNAS - 1)) / COLUMNAS;
    var tope = alto - MARGEN - 46;
    for (var indice = 0; indice < paginasProducto; indice++) {
      var pagina = documento.nuevaPagina();
      cabecera(pagina, ancho, alto, datos.titulo, empresa);
      pie(pagina, ancho, tienda, web, indice + 2, totalPaginas, T);
      var bloque = productos.slice(indice * porPagina, (indice + 1) * porPagina);
      bloque.forEach(function (producto, posicion) {
        var fila = Math.floor(posicion / COLUMNAS), columna = posicion % COLUMNAS;
        tarjeta(pagina, MARGEN + columna * (anchoTarjeta + GAP),
          tope - (fila + 1) * ALTO_TARJETA - fila * GAP,
          anchoTarjeta, ALTO_TARJETA, producto, fotos, lista,
          conStock, conEnlace, conCasilla, indice * porPagina + posicion + 1, T, sinPrecio);
      });
    }
    return documento.construir();
  }

  function portada(documento, datos, productos, fotos, info) {
    var pagina = documento.nuevaPagina();
    var ancho = documento.ancho, alto = documento.alto;

    var T = info.T || textos();
    pagina.rect(0, alto - 150, ancho, 150, { relleno: TEAL });
    pagina.texto(MARGEN, alto - 62, info.tienda, { tamano: 20, negrita: true, color: BLANCO });
    if (info.web) pagina.texto(MARGEN, alto - 80, info.web, { tamano: 10, color: [206, 235, 231] });
    pagina.texto(MARGEN, alto - 118, T.catalogoDe,
      { tamano: 9, negrita: true, color: [178, 224, 217] });

    var y = alto - 200;
    PDF.partir(datos.titulo, 30, ancho - 2 * MARGEN, true, 2).forEach(function (linea) {
      pagina.texto(MARGEN, y, linea, { tamano: 30, negrita: true, color: TEXTO });
      y -= 34;
    });

    // El cliente no tiene por que saber que lista de precios se le aplico.
    y -= 6;
    var conteo = T.productos(productos.length);
    var anchoChip = PDF.anchoTexto(conteo, 10, true) + 22;
    pagina.rect(MARGEN, y - 5, anchoChip, 22, { relleno: TEAL_SUAVE, radio: 11 });
    pagina.texto(MARGEN + 11, y + 2, conteo, { tamano: 10, negrita: true, color: TEAL });
    y -= 40;

    if (info.empresa) {
      pagina.rect(MARGEN, y - 44, ancho - 2 * MARGEN, 58, { relleno: FONDO, borde: BORDE, radio: 10 });
      pagina.texto(MARGEN + 16, y - 2, T.preparadoPara, { tamano: 8, negrita: true, color: MUDO });
      pagina.texto(MARGEN + 16, y - 26,
        PDF.recortar(info.empresa, 17, ancho - 2 * MARGEN - 32, true),
        { tamano: 17, negrita: true, color: TEXTO });
      y -= 74;
    }

    pagina.texto(MARGEN, y, fechaLarga(T.idioma), { tamano: 10, color: SUAVE });
    y -= 24;

    if (info.nota) {
      PDF.partir(info.nota, 10, ancho - 2 * MARGEN, false, 3).forEach(function (linea) {
        pagina.texto(MARGEN, y, linea, { tamano: 10, color: SUAVE });
        y -= 14;
      });
      y -= 8;
    }

    var mosaico = productos.filter(function (p) { return fotos[p.imagen]; }).slice(0, 4);
    if (mosaico.length) {
      var lado = Math.min((ancho - 2 * MARGEN - 30) / 4, Math.max(y - MARGEN - 40, 60));
      var base = y - lado - 6;
      mosaico.forEach(function (producto, posicion) {
        var x = MARGEN + posicion * (lado + 10);
        pagina.rect(x, base, lado, lado, { relleno: BLANCO, borde: BORDE, radio: 8 });
        pagina.imagen(producto.imagen, fotos[producto.imagen], x + 6, base + 6, lado - 12, lado - 12);
      });
    }

    pagina.linea(MARGEN, MARGEN + 26, ancho - MARGEN, MARGEN + 26, BORDE);
    pagina.texto(MARGEN, MARGEN + 12, T.pie, { tamano: 8, color: MUDO });
  }

  function cabecera(pagina, ancho, alto, titulo, empresa) {
    pagina.rect(0, alto - 26, ancho, 26, { relleno: TEAL });
    pagina.texto(MARGEN, alto - 18, PDF.recortar(String(titulo).toUpperCase(), 9, ancho / 2, true),
      { tamano: 9, negrita: true, color: BLANCO });
    pagina.texto(ancho / 2, alto - 18, PDF.recortar(empresa, 9, ancho / 2 - MARGEN),
      { tamano: 9, color: [206, 235, 231], alinear: "derecha", ancho: ancho / 2 - MARGEN });
  }

  function pie(pagina, ancho, tienda, web, numero, total, T) {
    pagina.linea(MARGEN, MARGEN + 16, ancho - MARGEN, MARGEN + 16, BORDE);
    pagina.texto(MARGEN, MARGEN + 4, web ? tienda + "   ·   " + web : tienda,
      { tamano: 8, color: MUDO });
    pagina.texto(MARGEN, MARGEN + 4, (T || textos()).pagina(numero, total),
      { tamano: 8, color: MUDO, alinear: "derecha", ancho: ancho - 2 * MARGEN });
  }

  function tarjeta(pagina, x, y, ancho, alto, producto, fotos, lista, stock, enlace, casilla, numero, T, sinPrecio) {
    T = T || textos();
    pagina.rect(x, y, ancho, alto, { relleno: BLANCO, borde: BORDE, radio: 10 });

    var caja = [x + 8, y + 86, ancho - 16, alto - 94];
    var foto = fotos[producto.imagen];
    if (!(foto && pagina.imagen(producto.imagen, foto, caja[0], caja[1], caja[2], caja[3]))) {
      pagina.rect(caja[0], caja[1], caja[2], caja[3], { relleno: FONDO, radio: 6 });
      pagina.texto(caja[0], caja[1] + caja[3] / 2 - 4, T.sinFoto,
        { tamano: 8, color: MUDO, alinear: "centro", ancho: caja[2] });
    }

    pagina.linea(x + 10, y + 78, x + ancho - 10, y + 78, BORDE);

    // El nombre del producto va arriba y la variante abajo, junto al SKU: si se
    // juntaran, en los productos de nombre largo la variante se cortaria y tres
    // colores del mismo modelo quedarian identicos.
    var linea = y + 67.5;
    PDF.partir(producto.producto || producto.titulo, 8.8, ancho - 20, true, 2)
      .forEach(function (texto) {
        pagina.texto(x + 10, linea, texto, { tamano: 8.8, negrita: true, color: TEXTO });
        linea -= 10.5;
      });

    var referencia = producto.sku || "";
    if (producto.variante) {
      referencia = referencia ? referencia + "  ·  " + producto.variante : producto.variante;
    }
    if (referencia) {
      pagina.texto(x + 10, y + 45, PDF.recortar(referencia, 7.5, ancho - 20),
        { tamano: 7.5, color: MUDO });
    }

    if (stock) {
      var cantidad = producto.existencia;
      var hay = cantidad === null || cantidad > 0;
      var texto = cantidad === null ? T.disponible :
        (cantidad > 0 ? T.existencia(cantidad) : T.bajoPedido);
      pagina.texto(x + 10, y + 32, texto,
        { tamano: 9, negrita: true, color: hay ? SUAVE : [183, 121, 31] });
    }

    // Catalogo sin precios: la tarjeta queda con foto, nombre, referencia y existencia.
    var precio = sinPrecio ? { valor: null, normal: null, aproximado: false } : comparacion(producto, lista);
    var etiqueta = dinero(precio.valor);
    if (producto.variosPrecios && lista === "normal") etiqueta = T.desde + etiqueta;
    if (!sinPrecio) pagina.texto(x + 10, y + 14, etiqueta, { tamano: 15, negrita: true, color: ROJO });
    if (sinPrecio) {
      // nada que mostrar
    } else if (precio.aproximado) {
      pagina.texto(x + 10, y + 6, T.precioNormal, { tamano: 6.5, color: MUDO });
    } else if (precio.normal !== null) {
      // El precio de siempre, tachado, para que se vea la diferencia.
      var izquierda = x + 10 + PDF.anchoTexto(etiqueta, 15, true) + 7;
      var tachado = dinero(precio.normal);
      var anchoTachado = PDF.anchoTexto(tachado, 8, false);
      if (izquierda + anchoTachado <= x + ancho - (casilla ? 58 : 12)) {
        pagina.texto(izquierda, y + 17, tachado, { tamano: 8, color: MUDO });
        pagina.linea(izquierda - 0.5, y + 19.9, izquierda + anchoTachado + 0.5, y + 19.9, MUDO, 0.6);
      }
    }

    if (casilla) {
      pagina.texto(x + ancho - 56, y + 31, T.cantidad,
        { tamano: 6.5, color: MUDO, alinear: "derecha", ancho: 46 });
      pagina.campo("cantidad_" + numero, x + ancho - 56, y + 8, 46, 20,
        { tamano: 10, fondo: [255, 248, 225], borde: [205, 212, 224] });
    }

    // El enlace deja libre la parte de abajo: si tapara la casilla, al tocarla
    // se abriria la web en vez de dejar escribir la cantidad.
    if (enlace && producto.url) pagina.enlace(x, y + 40, ancho, alto - 40, producto.url);
  }

  // ─── Excel ──────────────────────────────────────────────────────────

  function construirExcel(datos, opciones, fotos) {
    var productos = datos.productos;
    var lista = opciones.lista || "normal";
    var empresa = (opciones.empresa || "").trim();
    var conStock = !!opciones.existencia;
    var conEnlace = !!opciones.enlace;
    var conCasilla = !!opciones.cantidad;
    var conFotos = opciones.fotos !== false;
    var sinPrecio = !!opciones.sinPrecio;
    var T = textos(opciones.idioma);

    var libro = new XLSX.Libro(datos.titulo);
    var anchos = [];
    var cabeceras = [];
    if (conFotos) { anchos.push(16.5); cabeceras.push(T.colFoto); }
    var comparar = lista !== "normal" && !sinPrecio;
    anchos.push(22, 52);
    cabeceras.push(T.colReferencia, T.colProducto);
    if (sinPrecio) {
      // sin columnas de precio
    } else if (comparar) {
      anchos.push(14, 16);
      cabeceras.push(T.colPrecioNormal, T.colPrecioMayor);
    } else {
      anchos.push(15);
      cabeceras.push(T.colPrecio);
    }
    if (conStock) { anchos.push(12); cabeceras.push(T.colExistencia); }
    if (conCasilla) { anchos.push(15); cabeceras.push(T.colCantidad); }
    if (conEnlace) { anchos.push(16); cabeceras.push(T.colEnlace); }
    libro.anchos(anchos);

    var ultima = XLSX.letra(cabeceras.length - 1);
    libro.fila([{ valor: T.catalogo + " · " + datos.titulo, estilo: XLSX.TITULO }], 30);
    libro.combinar("A1", ultima + "1");

    var detalle = [fechaLarga(T.idioma)];
    if (empresa) detalle.unshift(T.preparadoParaExcel + empresa);
    libro.fila([{ valor: detalle.join("   ·   "), estilo: XLSX.SUBTITULO }], 18);
    libro.combinar("A2", ultima + "2");
    libro.fila([{ valor: (opciones.tienda || "") + "   ·   " + T.pie, estilo: XLSX.SUBTITULO }], 18);
    libro.combinar("A3", ultima + "3");
    libro.fila([]);

    libro.fila(cabeceras.map(function (texto) {
      return { valor: texto, estilo: XLSX.CABECERA };
    }), 26);
    libro.filasFijas = 5;

    var altoFila = conFotos ? 84 : 20;
    productos.forEach(function (producto) {
      var celdas = [];
      if (conFotos) celdas.push({ valor: "", estilo: XLSX.TEXTO });
      celdas.push({ valor: producto.sku || "", estilo: XLSX.SKU });
      celdas.push({ valor: producto.titulo || "", estilo: XLSX.TEXTO });
      var precio = comparacion(producto, lista);
      if (comparar) {
        var referencia = precio.normal !== null ? precio.normal : (producto.precios || {}).normal;
        celdas.push(referencia === null || referencia === undefined
          ? { valor: "-", estilo: XLSX.TACHADO }
          : { valor: referencia, estilo: XLSX.TACHADO, tipo: "n" });
      }
      if (!sinPrecio) {
        celdas.push(precio.valor === null
          ? { valor: "-", estilo: XLSX.PRECIO }
          : { valor: precio.valor, estilo: XLSX.PRECIO, tipo: "n" });
      }
      if (conStock) {
        celdas.push(producto.existencia === null
          ? { valor: T.sinControl, estilo: XLSX.ENTERO }
          : { valor: producto.existencia || 0, estilo: XLSX.ENTERO, tipo: "n" });
      }
      if (conCasilla) celdas.push({ valor: "", estilo: XLSX.CASILLA });
      if (conEnlace) {
        celdas.push(producto.url
          ? { valor: T.verProducto, estilo: XLSX.ENLACE, enlace: producto.url }
          : { valor: "", estilo: XLSX.TEXTO });
      }
      var fila = libro.fila(celdas, altoFila);

      var foto = conFotos ? fotos[producto.imagen] : null;
      if (foto) {
        var escala = Math.min(100 / foto.ancho, (altoFila / 0.75 - 8) / foto.alto);
        libro.imagen(fila, 0, foto.datos, foto.ancho * escala, foto.alto * escala);
      }
    });

    if (productos.length) libro.autofiltro = "A5:" + ultima + (5 + productos.length);
    return libro.construir();
  }

  return {
    LISTAS: LISTAS,
    etiquetaLista: etiquetaLista,
    precioDe: precioDe,
    comparacion: comparacion,
    fechaLarga: fechaLarga,
    textos: textos,
    dinero: dinero,
    bajarFotos: bajarFotos,
    construirPdf: construirPdf,
    construirExcel: construirExcel
  };
})();


(function () {
  "use strict";

  // ─── Ajustes ───────────────────────────────────────────────────────────
  // Código de acceso de la página. Deja "" para que no lo pida.
  var CODIGO_ACCESO = "sirena2026";
  // Fotos: ancho que se le pide al CDN y calidad del JPEG que se incrusta.
  var ANCHO_FOTO = [[350, 420], [700, 340], [1e9, 260]];
  var CALIDAD = 0.82;
  var DESCARGAS_A_LA_VEZ = 6;
  var MAX_PRODUCTOS = 1500;

  var config = window.__CATALOGO__ || { colecciones: [], listas: {}, sesion: false };

  var host = document.getElementById("catalogo-sirena-app");
  if (!host || host.dataset.listo) return;
  host.dataset.listo = "1";
  var root = host.attachShadow ? host.attachShadow({ mode: "open" }) : host;

  if (!document.querySelector('meta[name="robots"]')) {
    var meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
  }

  var estilos = document.createElement("style");
  estilos.textContent = ":host{--bg:#f4f6fa;--surface:#ffffff;--surface-2:#f8fafc;--border:#e3e8ef;--border-strong:#cfd6e2;--text:#101828;--text-soft:#5a6478;--text-mute:#8a94a6;--accent:#0f9d8e;--accent-strong:#0b7e73;--accent-soft:#e6f6f4;--ok:#0f9d58;--ok-soft:#e6f6ee;--warn:#b7791f;--warn-soft:#fdf3e2;--bad:#d64545;--bad-soft:#fdeceb;--shadow-sm:0 1px 2px rgba(16,24,40,.06);--shadow:0 10px 30px -14px rgba(16,24,40,.18),0 2px 6px rgba(16,24,40,.04);--shadow-lg:0 24px 60px -24px rgba(16,24,40,.35);display:block;margin:0 auto;max-width:1120px}.app,.acceso,.toasts{color:var(--text);font-family:\"Segoe UI Variable Text\",\"Segoe UI\",system-ui,-apple-system,Roboto,Helvetica,Arial,sans-serif;font-size:15px;font-weight:400;font-style:normal;line-height:1.5;letter-spacing:normal;word-spacing:normal;text-align:left;text-transform:none;text-indent:0;white-space:normal;word-break:normal;overflow-wrap:normal;hyphens:none;line-break:auto;tab-size:4;writing-mode:horizontal-tb;direction:ltr;visibility:visible;list-style:none}*,*::before,*::after{box-sizing:border-box}h1,h2,h3{margin:0;letter-spacing:-.02em;font-weight:650;color:var(--text)}p{margin:0}a{color:inherit}button,input,select,textarea{font-family:inherit}.hidden{display:none !important}.app{display:flex;flex-direction:column;gap:16px;padding:4px 0 24px}.hero{display:flex;align-items:center;gap:14px;padding:4px 2px 2px}.hero-icon{display:grid;place-items:center;width:44px;height:44px;flex:none;border-radius:13px;color:#fff;background:linear-gradient(145deg,var(--accent),var(--accent-strong));box-shadow:var(--shadow-sm)}.hero-icon svg{width:24px;height:24px}.hero h1{font-size:22px}.hero p{color:var(--text-soft);font-size:14px;margin-top:2px}.card{background:var(--surface);border:1px solid var(--border);border-radius:16px;box-shadow:var(--shadow);padding:22px}.step{display:flex;flex-direction:column;gap:16px}.step-head{display:flex;align-items:flex-start;gap:14px}.step-num{display:grid;place-items:center;width:30px;height:30px;flex:none;border-radius:9px;font-size:14px;font-weight:650;background:var(--accent-soft);color:var(--accent-strong);border:1px solid rgba(15,157,142,.28)}.step-head h2{font-size:17px}.step-head p{color:var(--text-soft);font-size:13.5px;margin-top:2px}.acceso{padding:40px 0}.acceso h2{font-size:18px}.acceso p{color:var(--text-soft);font-size:14px;margin-top:6px}.acceso-row{display:flex;gap:10px;margin-top:16px;flex-wrap:wrap}.acceso-row input{flex:1;min-width:180px;padding:10px 12px;border-radius:10px;border:1px solid var(--border);background:var(--surface-2);color:var(--text);font-size:14px}.primary{display:inline-flex;align-items:center;justify-content:center;gap:9px;padding:10px 18px;border-radius:11px;border:0;cursor:pointer;background:linear-gradient(140deg,var(--accent),var(--accent-strong));color:#fff;font-weight:600;font-size:14px;letter-spacing:-.01em;box-shadow:0 6px 18px -8px rgba(15,157,142,.8);transition:filter .15s,transform .1s,opacity .15s}.primary:hover:not(:disabled){filter:brightness(1.06)}.primary:active:not(:disabled){transform:translateY(1px)}.primary:disabled{opacity:.45;cursor:not-allowed;box-shadow:none}.primary.big{padding:12px 24px;font-size:15px}.ghost{padding:9px 14px;border-radius:10px;cursor:pointer;border:1px solid var(--border);background:var(--surface);color:var(--text-soft);font-size:13.5px;transition:border-color .15s,color .15s}.ghost:hover{border-color:var(--border-strong);color:var(--text)}.is-busy{position:relative;color:transparent !important;pointer-events:none}.is-busy::after{content:\"\";position:absolute;inset:0;margin:auto;width:17px;height:17px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:girar .7s linear infinite}@keyframes girar{to{transform:rotate(360deg)}}.tabs{display:inline-flex;gap:4px;padding:4px;border-radius:12px;background:var(--surface-2);border:1px solid var(--border);align-self:flex-start}.tab{padding:7px 15px;border-radius:9px;border:0;background:transparent;color:var(--text-soft);cursor:pointer;font-size:13.5px;font-weight:500}.tab.is-active{background:var(--surface);color:var(--text);box-shadow:var(--shadow-sm)}.pane{display:flex;flex-direction:column;gap:10px}.dropzone{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:36px 20px;text-align:center;cursor:pointer;border:1.5px dashed var(--border-strong);border-radius:14px;background:var(--surface-2);color:var(--text-soft);transition:border-color .15s,background .15s}.dropzone:hover,.dropzone.is-over{border-color:var(--accent);background:var(--accent-soft)}.dropzone strong{color:var(--text);font-size:15px}.dropzone span{font-size:13px}.dz-icon{width:30px;height:30px;color:var(--accent);margin-bottom:4px}textarea{width:100%;min-height:150px;resize:vertical;padding:14px;border-radius:12px;border:1px solid var(--border);background:var(--surface-2);color:var(--text);font-family:ui-monospace,\"Cascadia Mono\",Consolas,monospace;font-size:13px;line-height:1.6}textarea:focus-visible,input:focus-visible,select:focus-visible,button:focus-visible{outline:2px solid rgba(15,157,142,.6);outline-offset:2px}.hint{color:var(--text-mute);font-size:12.5px}.row-between{display:flex;align-items:center;justify-content:space-between;gap:16px}.row-between.wrap{flex-wrap:wrap}.mapping{display:flex;flex-direction:column;gap:14px;padding-top:16px;border-top:1px solid var(--border)}.mapping-head{display:flex;flex-wrap:wrap;gap:14px 20px;align-items:flex-end;justify-content:space-between}.file-chip{display:inline-flex;align-items:center;gap:9px;padding:8px 10px 8px 12px;border-radius:10px;border:1px solid var(--border);background:var(--surface-2);font-size:13.5px;max-width:100%}.file-chip svg{width:16px;height:16px;color:var(--accent);flex:none}.file-chip span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.file-chip button{border:0;background:transparent;color:var(--text-mute);cursor:pointer;padding:0 2px;font-size:13px}.file-chip button:hover{color:var(--bad)}.mapping-selects{display:flex;flex-wrap:wrap;align-items:flex-end;gap:12px}.field{display:flex;flex-direction:column;gap:5px;font-size:12.5px;color:var(--text-soft)}.field>span{font-weight:500}.field select,.field input{padding:9px 11px;border-radius:10px;border:1px solid var(--border);background:var(--surface);color:var(--text);font-size:13.5px;min-width:180px;max-width:320px}.field.compact select{min-width:150px;padding:8px 10px}.field.compact input{min-width:110px;max-width:130px;padding:8px 10px}.check{display:inline-flex;align-items:center;gap:8px;font-size:13.5px;color:var(--text-soft);cursor:pointer}.check input{width:16px;height:16px;accent-color:var(--accent);cursor:pointer}.preview{background:var(--surface-2);border:1px solid var(--border);border-radius:12px;padding:12px 14px}.preview-head{display:flex;align-items:baseline;gap:10px;margin-bottom:8px}.preview-head strong{font-size:14px}.preview-head span{font-size:12.5px;color:var(--text-mute)}.sku-preview{display:flex;flex-wrap:wrap;gap:6px}.sku-tag{padding:4px 9px;border-radius:7px;font-size:12px;font-family:ui-monospace,\"Cascadia Mono\",Consolas,monospace;background:var(--surface);border:1px solid var(--border);color:var(--text-soft)}.sku-tag.more{background:transparent;border-style:dashed}.progress{height:5px;border-radius:999px;background:var(--surface-2);overflow:hidden}.progress>div{height:100%;width:2%;border-radius:999px;background:linear-gradient(90deg,var(--accent),var(--accent-strong));transition:width .25s ease}.stats{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;margin-bottom:16px}.stat{display:flex;flex-direction:column;gap:2px;padding:14px 16px;border-radius:13px;border:1px solid var(--border);background:var(--surface);box-shadow:var(--shadow-sm)}.stat strong{font-size:24px;letter-spacing:-.03em;line-height:1.15}.stat span{font-size:12.5px;color:var(--text-mute)}.stat.ok strong{color:var(--ok)}.stat.warn strong{color:var(--warn)}.stat.bad strong{color:var(--bad)}.stat.accent strong{color:var(--accent)}.table-card{padding:0;overflow:hidden}.toolbar{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;padding:14px 16px;border-bottom:1px solid var(--border);background:var(--surface-2)}.filters{display:flex;flex-wrap:wrap;gap:6px}.pill{padding:6px 12px;border-radius:999px;cursor:pointer;font-size:13px;border:1px solid var(--border);background:var(--surface);color:var(--text-soft)}.pill:hover{color:var(--text);border-color:var(--border-strong)}.pill.is-active{background:var(--accent);border-color:var(--accent);color:#fff}.toolbar-right{display:flex;align-items:center;gap:8px;flex-wrap:wrap}.search-input{padding:8px 12px;border-radius:10px;border:1px solid var(--border);background:var(--surface);color:var(--text);font-size:13.5px;min-width:200px}.table-wrap{max-height:60vh;overflow-y:auto;overflow-x:hidden}table{width:100%;table-layout:fixed;border-collapse:collapse;margin:0}thead th{position:sticky;top:0;z-index:2;text-align:left;font-size:11.5px;text-transform:uppercase;letter-spacing:.06em;color:var(--text-mute);font-weight:600;padding:11px 12px;white-space:nowrap;background:var(--surface);border-bottom:1px solid var(--border)}tbody td{padding:9px 12px;border-bottom:1px solid var(--border);vertical-align:middle;background:transparent}tbody tr:hover{background:var(--surface-2)}tbody tr.is-missing td{color:var(--text-mute)}.col-check{width:42px}.col-thumb{width:58px}.col-sku{width:172px}.col-title{width:auto}.col-count{width:104px}.col-open{width:38px}.col-check input{width:16px;height:16px;accent-color:var(--accent);cursor:pointer}.thumb{width:44px;height:44px;border-radius:9px;object-fit:cover;display:block;background:var(--surface-2);border:1px solid var(--border)}.thumb-empty{display:grid;place-items:center;color:var(--text-mute);font-size:16px}.sku-cell{font-family:ui-monospace,\"Cascadia Mono\",Consolas,monospace;font-size:13px;font-weight:500;white-space:nowrap;word-break:keep-all;overflow-wrap:normal;overflow:hidden;text-overflow:ellipsis}.sku-cell small{display:block;font-family:inherit;color:var(--warn);font-size:11px;margin-top:2px}.title-cell{font-size:13.5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-break:keep-all}.title-cell a{color:inherit;text-decoration:none}.title-cell a:hover{color:var(--accent);text-decoration:underline}.badge{display:inline-flex;align-items:center;padding:3px 9px;border-radius:999px;font-size:12px;font-weight:500;white-space:nowrap}.badge.ok{background:var(--ok-soft);color:var(--ok)}.badge.warn{background:var(--warn-soft);color:var(--warn)}.badge.bad{background:var(--bad-soft);color:var(--bad)}.badge.mute{background:var(--surface-2);color:var(--text-mute);border:1px solid var(--border)}.expand{border:0;background:transparent;color:var(--text-mute);cursor:pointer;padding:4px 6px;border-radius:8px;font-size:12px}.expand:hover{color:var(--accent);background:var(--accent-soft)}.gallery-row td{padding:0 12px 14px 66px;background:var(--surface-2)}.gallery{display:flex;flex-wrap:wrap;gap:10px}.gallery figure{margin:0;position:relative;cursor:pointer}.gallery img{width:76px;height:76px;object-fit:cover;border-radius:10px;border:2px solid var(--border);display:block;background:var(--surface)}.gallery figure.is-on img{border-color:var(--accent)}.gallery figure .mark{position:absolute;top:-6px;right:-6px;width:20px;height:20px;border-radius:50%;display:grid;place-items:center;font-size:11px;color:#fff;background:var(--accent);box-shadow:var(--shadow-sm);opacity:0;transition:opacity .12s}.gallery figure.is-on .mark{opacity:1}.empty{padding:26px;text-align:center;color:var(--text-mute);font-size:13.5px}.actionbar{position:sticky;bottom:0;z-index:5;margin-top:16px;display:flex;align-items:flex-end;justify-content:space-between;gap:16px;flex-wrap:wrap;padding:14px 18px;border-radius:16px;background:rgba(255,255,255,.92);backdrop-filter:blur(14px);border:1px solid var(--border);box-shadow:var(--shadow-lg)}.selection{display:flex;flex-direction:column}.selection strong{font-size:17px;letter-spacing:-.02em}.selection span{font-size:12.5px;color:var(--text-mute)}.actionbar-options{display:flex;align-items:flex-end;gap:10px;flex-wrap:wrap}.modal{position:fixed;inset:0;z-index:2147482000;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(9,14,24,.55);backdrop-filter:blur(3px)}.modal-card{width:min(520px,100%);max-height:calc(100vh - 36px);overflow:auto;background:#fff;border:1px solid var(--border);border-radius:16px;box-shadow:var(--shadow-lg)}.modal-head{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid var(--border)}.modal-head h2{font-size:16px}.modal-head button{background:none;border:0;cursor:pointer;font-size:16px;color:var(--text-mute);padding:4px 8px;border-radius:8px}.modal-head button:hover{background:var(--surface-2);color:var(--text)}.modal-body{display:flex;flex-direction:column;gap:14px;padding:20px}.modal-body .field input{min-width:0;width:100%}.modal-body textarea{min-height:92px;padding:10px 12px;font-family:inherit;font-size:13.5px;line-height:1.5}.modal-resumen{font-size:13px;color:var(--text-soft);padding:10px 12px;border-radius:10px;background:var(--surface-2);border:1px solid var(--border)}.modal-actions{display:flex;justify-content:space-between;gap:10px;margin-top:4px}.toasts{position:fixed;right:18px;bottom:18px;z-index:2147483000;display:flex;flex-direction:column;gap:8px;align-items:flex-end}.toast{padding:11px 15px;border-radius:12px;background:#fff;color:#101828;border:1px solid var(--border);box-shadow:var(--shadow-lg);font-size:13.5px;max-width:340px;transition:opacity .25s}.toast.ok{border-left:3px solid var(--ok)}.toast.error{border-left:3px solid var(--bad)}.toast.info{border-left:3px solid var(--accent)}@media (max-width:640px){.col-thumb,tbody td.col-thumb{display:none}.col-sku{width:120px}.col-count{width:88px}.badge{font-size:11px;padding:3px 7px}.gallery-row td{padding-left:14px}}@media (max-width:720px){.toolbar-right{width:100%}.search-input{flex:1;min-width:0}.actionbar-options{width:100%;display:grid;grid-template-columns:1fr 1fr;gap:8px}.actionbar-options .field.compact select{min-width:0;width:100%}.actionbar-options .field:nth-child(3){grid-column:1 / -1}.actionbar-options .primary{grid-column:1 / -1;width:100%}.actionbar-options .ghost.big{grid-column:1 / -1;width:100%}.toasts{left:12px;right:12px;align-items:stretch}}.grow{flex:1;min-width:240px}.sesion{margin-left:auto;font-size:12.5px;color:var(--text-mute);text-align:right}.sesion b{color:var(--accent-strong)}.col-grid{display:grid;gap:10px;grid-template-columns:repeat(auto-fill,minmax(190px,1fr));max-height:320px;overflow-y:auto;padding:2px}.col-item{display:flex;flex-direction:column;gap:2px;text-align:left;cursor:pointer;padding:11px 13px;border-radius:10px;font:inherit;font-size:15px;border:1px solid var(--border);background:var(--surface);color:var(--text);transition:border-color .12s,transform .1s,background .12s}.col-item:hover{border-color:var(--accent);transform:translateY(-1px)}.col-item strong{font-size:13.5px;letter-spacing:-.01em}.col-item span{font-size:12px;color:var(--text-mute)}.col-item.is-all{border-style:dashed;border-color:var(--border-strong)}.col-item.is-all strong::before{content:\"\\2605 \";color:var(--accent)}.col-item.is-active{border-color:var(--accent);background:var(--accent-soft);box-shadow:0 0 0 1px var(--accent) inset}.col-item{position:relative}.col-item.is-active::after{content:\"\\2713\";position:absolute;top:8px;right:10px;width:18px;height:18px;border-radius:50%;display:grid;place-items:center;font-size:11px;color:#fff;background:var(--accent)}.col-item.is-active strong{padding-right:22px}.segment{display:flex;flex-wrap:wrap;gap:6px;padding:4px;width:fit-content;border-radius:12px;background:var(--surface-2);border:1px solid var(--border)}.segment-btn{padding:8px 16px;border-radius:9px;border:1px solid transparent;cursor:pointer;background:transparent;color:var(--text-soft);font:inherit;font-size:13.5px}.segment-btn:hover:not(:disabled){color:var(--text)}.segment-btn:disabled{opacity:.4;cursor:not-allowed}.segment-btn.is-active{background:var(--surface);color:var(--accent-strong);border-color:var(--border);font-weight:600;box-shadow:var(--shadow-sm)}.grid-2{display:grid;gap:14px;grid-template-columns:repeat(auto-fit,minmax(260px,1fr))}.check-row{display:flex;flex-wrap:wrap;align-items:center;gap:10px 22px}.col-price{width:130px;white-space:nowrap}.col-price b{font-size:14.5px;color:var(--bad)}.col-price em{display:block;font-style:normal;font-size:11px;color:var(--text-mute)}.mute-cell{color:var(--text-mute)}tbody tr.is-off{opacity:.42}tbody tr.is-off:hover{opacity:.72}.progreso{position:fixed;inset:0;z-index:80;display:grid;place-items:center;background:rgba(9,14,24,.55)}.progreso-caja{background:var(--surface);border-radius:16px;padding:24px 28px;min-width:300px;box-shadow:var(--shadow-lg);display:flex;flex-direction:column;gap:10px;font-family:\"Segoe UI Variable Text\",\"Segoe UI\",system-ui,sans-serif;color:var(--text)}.progreso-caja .barra{height:8px;border-radius:999px;background:var(--surface-2);overflow:hidden}.progreso-caja .barra>div{height:100%;width:0;border-radius:999px;background:var(--accent);transition:width .2s}.progreso-caja span{font-size:13px;color:var(--text-mute)}@media (max-width:720px){.col-grid{grid-template-columns:1fr 1fr;max-height:260px}.segment{width:100%}.segment-btn{flex:1;text-align:center;padding:8px 6px}.col-price{width:100px}.sesion{display:none}}";
  root.appendChild(estilos);
  var caja = document.createElement("div");
  caja.innerHTML = "<div class=\"acceso hidden\"><div class=\"card\"><h2>Herramienta interna</h2><p>Escribe el código de acceso para continuar.</p><div class=\"acceso-row\"><input id=\"acceso-input\" type=\"password\" placeholder=\"Código\"><button id=\"acceso-btn\" class=\"primary\" type=\"button\">Entrar</button></div></div></div><div class=\"app\"><header class=\"hero\"><div class=\"hero-icon\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M14 3v5h5\"/><path d=\"M6 3h8l5 5v13H6z\"/><path d=\"M9 13h6\"/><path d=\"M9 17h4\"/></svg></div><div><h1>Catálogo por colección</h1><p>Elige una o varias colecciones y baja el PDF o el Excel, listos para mandarle al cliente.</p></div><div id=\"sesion\" class=\"sesion\"></div></header><!-- paso 1 --><section class=\"card step\"><header class=\"step-head\"><span class=\"step-num\">1</span><div><h2>Elige una o varias colecciones</h2><p>Haz clic en cada colección que quieras incluir; otro clic la quita. Salen juntas en un solo catálogo.</p></div></header><div class=\"row-between wrap\"><input id=\"buscar-coleccion\" class=\"search-input grow\" type=\"search\" placeholder=\"Buscar colección…\" autocomplete=\"off\"><span id=\"elegidas\" class=\"hint hidden\"></span><button class=\"ghost hidden\" type=\"button\" id=\"limpiar-colecciones\">Quitar selección</button></div><div id=\"colecciones\" class=\"col-grid\"></div><p id=\"colecciones-vacio\" class=\"empty hidden\">Ninguna colección coincide con la búsqueda.</p></section><!-- paso 2 --><section id=\"opciones\" class=\"card step hidden\"><header class=\"step-head\"><span class=\"step-num\">2</span><div><h2>Precio y datos del catálogo</h2><p>Lo que elijas aquí se aplica al PDF y al Excel.</p></div></header><div class=\"segment\" id=\"listas\" role=\"group\" aria-label=\"Lista de precios\"></div><p id=\"aviso-listas\" class=\"hint hidden\"></p><div class=\"row-between wrap\" style=\"margin-top:10px\"><label class=\"field\"><span>Idioma del catálogo (PDF y Excel)</span><div class=\"segment\" id=\"idiomas\" role=\"group\" aria-label=\"Idioma del catálogo\"><button type=\"button\" class=\"segment-btn is-active\" data-idioma=\"es\">Español</button><button type=\"button\" class=\"segment-btn\" data-idioma=\"en\">English</button></div></label><p class=\"hint\">En inglés, los nombres de productos y colecciones salen de la traducción de la tienda.</p></div><div class=\"grid-2\"><label class=\"field\"><span>A nombre de (opcional)</span><input id=\"empresa\" type=\"text\" placeholder=\"Distribuidora El Progreso, S.A.\" autocomplete=\"off\" maxlength=\"80\"></label><label class=\"field\"><span>Nota en la portada (opcional)</span><input id=\"nota\" type=\"text\" placeholder=\"Precios válidos por 15 días.\" autocomplete=\"off\" maxlength=\"300\"></label></div><div class=\"check-row\"><label class=\"check\"><input type=\"checkbox\" id=\"opt-existencia\" checked> Mostrar existencia</label><label class=\"check\"><input type=\"checkbox\" id=\"opt-enlace\" checked> Incluir enlace al producto</label><label class=\"check\"><input type=\"checkbox\" id=\"opt-cantidad\" checked> Casilla para anotar cantidad</label><label class=\"check\"><input type=\"checkbox\" id=\"opt-fotos\" checked> Fotos dentro del Excel</label><label class=\"check\"><input type=\"checkbox\" id=\"opt-sinprecio\"> Sin precios</label></div><div class=\"check-row\"><label class=\"check\"><input type=\"checkbox\" id=\"opt-stock\"> Solo con existencia</label><label class=\"field compact\"><span>Existencia mínima</span><input id=\"min-existencia\" type=\"number\" min=\"0\" step=\"1\" value=\"0\" inputmode=\"numeric\"placeholder=\"0\" title=\"Solo salen los productos con esta existencia o más. 0 = todos.\"></label><label class=\"field compact\"><span>Orden</span><select id=\"orden\"><option value=\"tienda\">Como en la tienda</option><option value=\"referencia\">Referencia A → Z</option><option value=\"referencia-desc\">Referencia Z → A</option><option value=\"nombre\">Nombre A → Z</option><option value=\"precio\">Precio de menor a mayor</option><option value=\"precio-desc\">Precio de mayor a menor</option><option value=\"existencia\">Más existencia primero</option></select></label></div></section><!-- paso 3 --><section id=\"resultados\" class=\"hidden\"><div class=\"stats\"><div class=\"stat accent\"><strong id=\"stat-total\">0</strong><span>en el catálogo</span></div><div class=\"stat ok\"><strong id=\"stat-stock\">0</strong><span>con existencia</span></div><div class=\"stat warn\"><strong id=\"stat-sinlista\">0</strong><span>sin precio de esa lista</span></div><div class=\"stat mute\"><strong id=\"stat-sinfoto\">0</strong><span>sin foto</span></div></div><div class=\"card table-card\"><div class=\"toolbar\"><strong id=\"titulo-coleccion\">Colección</strong><div class=\"toolbar-right\"><input id=\"filtro\" class=\"search-input\" type=\"search\" placeholder=\"Filtrar por referencia o producto…\"><button class=\"ghost\" type=\"button\" id=\"alternar\">Quitar todos</button></div></div><div class=\"table-wrap\"><table><thead><tr><th class=\"col-check\"><input type=\"checkbox\" id=\"todos\" checked aria-label=\"Seleccionar todo\"></th><th class=\"col-thumb\"></th><th>Referencia</th><th>Producto</th><th class=\"col-price\" id=\"th-precio\">Precio</th><th class=\"col-count\">Existencia</th></tr></thead><tbody id=\"filas\"></tbody></table></div><p id=\"sin-filas\" class=\"empty hidden\">Ninguna fila coincide con el filtro.</p></div></section></div><div id=\"barra\" class=\"actionbar hidden\"><div class=\"actionbar-inner\"><div class=\"selection\"><strong id=\"seleccion\">0 productos</strong><span id=\"detalle\">Precio normal</span></div><div class=\"actionbar-options\"><button id=\"btn-pdf\" class=\"primary big\" type=\"button\"><span class=\"btn-label\">Descargar PDF</span></button><button id=\"btn-excel\" class=\"ghost big\" type=\"button\"><span class=\"btn-label\">Descargar Excel</span></button></div></div></div><div id=\"progreso\" class=\"progreso hidden\"><div class=\"progreso-caja\"><strong id=\"progreso-titulo\">Preparando el catálogo…</strong><div class=\"barra\"><div id=\"barra-relleno\"></div></div><span id=\"progreso-detalle\">Descargando fotos</span></div></div><div id=\"avisos\" class=\"toasts\" aria-live=\"polite\"></div>";
  root.appendChild(caja);

  var $ = function (selector) { return root.querySelector(selector); };
  var $$ = function (selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); };

  var estado = {
    coleccion: null,    // la primera elegida (o null)
    colecciones: [],    // todas las elegidas, en el orden en que se marcaron
    cache: {},          // productos ya pedidos, por idioma + handle
    productos: [],
    fuera: {},          // variantes quitadas a mano, por id
    lista: "normal",
    idioma: "es",       // idioma del PDF/Excel: "es" o "en"
    tituloDocumento: "",// titulo de la coleccion (o colecciones) en ese idioma
    busqueda: "",
    filtro: ""
  };

  // ─── utilidades ────────────────────────────────────────────────────────

  function aviso(mensaje, tipo, ms) {
    var nodo = document.createElement("div");
    nodo.className = "toast " + (tipo || "info");
    nodo.textContent = mensaje;
    $("#avisos").appendChild(nodo);
    setTimeout(function () {
      nodo.style.opacity = "0";
      nodo.style.transition = "opacity .2s";
      setTimeout(function () { nodo.remove(); }, 220);
    }, ms || 4500);
  }

  function ocupado(boton, si) {
    boton.classList.toggle("is-busy", si);
    boton.disabled = si;
  }

  function normalizar(texto) {
    return String(texto == null ? "" : texto).toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "");
  }

  function conProtocolo(url) {
    if (!url) return "";
    return url.indexOf("//") === 0 ? "https:" + url : url;
  }

  function anchoFoto(cantidad) {
    for (var i = 0; i < ANCHO_FOTO.length; i++) {
      if (cantidad <= ANCHO_FOTO[i][0]) return ANCHO_FOTO[i][1];
    }
    return 260;
  }

  function nombreArchivo(extension) {
    // Sin la lista de precios: el nombre del archivo lo ve el cliente.
    var partes = [estado.idioma === "en" ? "Catalog" : "Catalogo", estado.tituloDocumento || estado.coleccion.titulo];
    var empresa = $("#empresa").value.trim();
    if (empresa) partes.push(empresa);
    partes.push(new Date().toISOString().slice(0, 10));
    return partes.join("-").replace(/[^A-Za-z0-9áéíóúüñÁÉÍÓÚÜÑ]+/g, "-")
      .replace(/^-+|-+$/g, "").slice(0, 110) + extension;
  }

  function descargar(nombre, bytes, tipo) {
    var enlace = document.createElement("a");
    enlace.href = URL.createObjectURL(new Blob([bytes], { type: tipo }));
    enlace.download = nombre;
    document.body.appendChild(enlace);
    enlace.click();
    enlace.remove();
    setTimeout(function () { URL.revokeObjectURL(enlace.href); }, 4000);
  }

  // ─── código de acceso ──────────────────────────────────────────────────

  var LLAVE = "catalogo-sirena-acceso";

  function pedirAcceso() {
    if (!CODIGO_ACCESO) return true;
    try {
      if (localStorage.getItem(LLAVE) === CODIGO_ACCESO) return true;
    } catch (error) { /* navegación privada */ }
    $(".acceso").classList.remove("hidden");
    $(".app").classList.add("hidden");
    $("#acceso-btn").addEventListener("click", comprobar);
    $("#acceso-input").addEventListener("keydown", function (evento) {
      if (evento.key === "Enter") comprobar();
    });
    return false;
  }

  function comprobar() {
    if ($("#acceso-input").value.trim() !== CODIGO_ACCESO) {
      aviso("Código incorrecto.", "error");
      return;
    }
    try { localStorage.setItem(LLAVE, CODIGO_ACCESO); } catch (error) { /* nada */ }
    $(".acceso").classList.add("hidden");
    $(".app").classList.remove("hidden");
    arrancar();
  }

  // ─── colecciones ───────────────────────────────────────────────────────

  function pintarColecciones() {
    var caja = $("#colecciones");
    var aguja = normalizar(estado.busqueda);
    var lista = config.colecciones.filter(function (item) {
      return normalizar(item.titulo).indexOf(aguja) >= 0;
    });
    caja.innerHTML = "";
    lista.forEach(function (item) {
      var boton = document.createElement("button");
      boton.type = "button";
      boton.className = "col-item";
      if (item.handle === "all") boton.classList.add("is-all");
      var marcada = estado.colecciones.some(function (c) { return c.handle === item.handle; });
      if (marcada) boton.classList.add("is-active");
      boton.setAttribute("aria-pressed", marcada ? "true" : "false");
      var titulo = document.createElement("strong");
      titulo.textContent = item.titulo;
      var cuenta = document.createElement("span");
      cuenta.textContent = item.cuenta + " producto" + (item.cuenta === 1 ? "" : "s");
      boton.appendChild(titulo);
      boton.appendChild(cuenta);
      boton.addEventListener("click", function () { elegirColeccion(item); });
      caja.appendChild(boton);
    });
    $("#colecciones-vacio").classList.toggle("hidden", lista.length > 0);
    var cuantas = estado.colecciones.length;
    $("#elegidas").textContent = cuantas + " colecciones elegidas";
    $("#elegidas").classList.toggle("hidden", cuantas < 2);
    $("#limpiar-colecciones").classList.toggle("hidden", cuantas < 1);
  }

  /** "Abanicos", "Abanicos y Camas", "Abanicos, Camas y 3 mas". */
  function unirTitulos(titulos, idioma) {
    var y = idioma === "en" ? " and " : " y ";
    if (titulos.length <= 1) return titulos[0] || "";
    if (titulos.length <= 3) return titulos.slice(0, -1).join(", ") + y + titulos[titulos.length - 1];
    return titulos.slice(0, 2).join(", ") + y + (titulos.length - 2) + (idioma === "en" ? " more" : " más");
  }

  /** Junta las colecciones elegidas en una sola lista: en el orden en que se
      marcaron y sin repetir la variante que este en mas de una. */
  async function cargarElegidas() {
    var vistos = {};
    var productos = [];
    var titulos = [];
    for (var i = 0; i < estado.colecciones.length; i++) {
      var item = estado.colecciones[i];
      var llave = estado.idioma + "|" + item.handle;
      if (!estado.cache[llave]) {
        mostrarProgreso("Cargando " + item.titulo, "Pidiendo los productos a la tienda");
        estado.cache[llave] = await cargarProductos(item.handle, estado.idioma);
      }
      var parte = estado.cache[llave];
      titulos.push(parte.titulo || item.titulo);
      parte.productos.forEach(function (producto) {
        if (vistos[producto.id]) return;
        vistos[producto.id] = true;
        productos.push(producto);
      });
    }
    if (productos.length > MAX_PRODUCTOS) {
      aviso("Son " + productos.length + " productos: el catálogo se corta en los primeros " + MAX_PRODUCTOS + ".", "info", 8000);
      productos = productos.slice(0, MAX_PRODUCTOS);
    }
    estado.productos = productos;
    estado.tituloDocumento = unirTitulos(titulos, estado.idioma);
  }

  /** Marca o desmarca una coleccion. "Todos los productos" ya lo trae todo,
      asi que no se combina con las demas. */
  async function elegirColeccion(item) {
    var antes = estado.colecciones.slice();
    var yaEstaba = antes.some(function (c) { return c.handle === item.handle; });
    if (yaEstaba) {
      estado.colecciones = antes.filter(function (c) { return c.handle !== item.handle; });
    } else if (item.handle === "all") {
      estado.colecciones = [item];
    } else {
      estado.colecciones = antes.filter(function (c) { return c.handle !== "all"; }).concat([item]);
    }
    await aplicarColecciones(antes, !yaEstaba && antes.length === 0);
  }

  async function aplicarColecciones(antes, desplazar) {
    estado.coleccion = estado.colecciones[0] || null;
    pintarColecciones();
    var hay = estado.colecciones.length > 0;
    $("#opciones").classList.toggle("hidden", !hay);
    $("#resultados").classList.toggle("hidden", !hay);
    if (!hay) {
      estado.productos = [];
      estado.fuera = {};
      estado.tituloDocumento = "";
      actualizarBarra();
      return;
    }
    try {
      await cargarElegidas();
      estado.filtro = "";
      $("#filtro").value = "";
      $("#titulo-coleccion").textContent = unirTitulos(
        estado.colecciones.map(function (c) { return c.titulo; }), "es");
      pintar();
      if (desplazar) $("#opciones").scrollIntoView({ behavior: "smooth", block: "start" });
    } catch (error) {
      // No se pudo cargar: se vuelve a la seleccion que habia.
      estado.colecciones = antes;
      estado.coleccion = antes[0] || null;
      pintarColecciones();
      $("#opciones").classList.toggle("hidden", !antes.length);
      $("#resultados").classList.toggle("hidden", !antes.length);
      aviso("No se pudieron cargar los productos: " + error.message, "error", 9000);
    } finally {
      esconderProgreso();
    }
  }

  /** Pide el JSON de la plantilla del tema, de 50 en 50. */
  async function cargarProductos(handle, idioma) {
    var productos = [];
    var titulo = "";
    var pagina = 1;
    var paginas = 1;
    do {
      // En ingles se pide por /en/...: Shopify devuelve titulos y variantes traducidos.
      var respuesta = await fetch((idioma === "en" ? "/en" : "") + "/collections/" + encodeURIComponent(handle) +
        "?view=datos&page=" + pagina, { credentials: "same-origin" });
      if (!respuesta.ok) throw new Error("la tienda respondió " + respuesta.status);
      var texto = await respuesta.text();
      var datos;
      try {
        datos = JSON.parse(texto);
      } catch (error) {
        throw new Error("falta la plantilla collection.datos.liquid en el tema");
      }
      paginas = datos.paginas || 1;
      if (pagina === 1) titulo = datos.titulo || "";
      (datos.productos || []).forEach(function (crudo) {
        // Cada fila es una variante: nombre del producto + el de la variante,
        // con su propio SKU y su propia foto.
        var variante = (crudo.variante || "").trim();
        productos.push({
          id: String(crudo.id || crudo.sku || crudo.handle),
          titulo: variante ? crudo.titulo + " · " + variante : crudo.titulo,
          producto: crudo.titulo,
          variante: variante,
          handle: crudo.handle,
          sku: crudo.sku || "",
          imagen: conProtocolo(crudo.imagen),
          url: crudo.url || "",
          existencia: crudo.existencia === null ? null : (crudo.existencia || 0),
          variosPrecios: false,
          precios: {
            normal: crudo.precio,
            a: crudo.a === null ? null : Number(crudo.a),
            b: crudo.b === null ? null : Number(crudo.b),
            c: crudo.c === null ? null : Number(crudo.c)
          }
        });
      });
      actualizarProgreso(productos.length, (datos.total || productos.length),
        "Productos leídos: " + productos.length);
      pagina++;
    } while (pagina <= paginas && productos.length < MAX_PRODUCTOS);
    return { titulo: titulo, productos: productos };
  }

  // ─── listas de precio ──────────────────────────────────────────────────

  function pintarListas() {
    var caja = $("#listas");
    caja.innerHTML = "";
    Object.keys(DOCUMENTOS.LISTAS).forEach(function (clave) {
      var permitida = clave === "normal" || config.listas[clave];
      var boton = document.createElement("button");
      boton.type = "button";
      boton.className = "segment-btn" + (clave === estado.lista ? " is-active" : "");
      boton.textContent = DOCUMENTOS.LISTAS[clave];
      boton.disabled = !permitida;
      if (!permitida) boton.title = "Tu cuenta no tiene permiso para esta lista";
      boton.addEventListener("click", function () {
        estado.lista = clave;
        pintarListas();
        pintar();
      });
      caja.appendChild(boton);
    });

    var faltan = ["a", "b", "c"].filter(function (clave) { return !config.listas[clave]; });
    var texto = "";
    if (!config.sesion) {
      texto = "Solo se ve el precio normal: inicia sesión con tu cuenta de vendedor para ver las listas de mayoreo.";
    } else if (faltan.length) {
      texto = "Tu cuenta no tiene permiso para " +
        faltan.map(function (c) { return "Lista " + c.toUpperCase(); }).join(", ") + ".";
    }
    $("#aviso-listas").textContent = texto;
    $("#aviso-listas").classList.toggle("hidden", !texto);
  }

  // ─── idioma del documento ─────────────────────────────────────────────

  function pintarIdiomas() {
    $$("#idiomas .segment-btn").forEach(function (boton) {
      boton.classList.toggle("is-active", boton.dataset.idioma === estado.idioma);
    });
  }

  /** Cambia el idioma del PDF/Excel. Los nombres traducidos vienen de la
      tienda (/en/...), asi que hay que volver a pedir los productos; las
      variantes quitadas a mano se conservan porque el id es el mismo. */
  async function cambiarIdioma(idioma) {
    if (idioma === estado.idioma) return;
    estado.idioma = idioma;
    pintarIdiomas();
    actualizarBarra();
    if (!estado.coleccion) return;
    try {
      await cargarElegidas();
      pintar();
    } catch (error) {
      aviso("No se pudieron cargar los productos: " + error.message, "error", 9000);
    } finally {
      esconderProgreso();
    }
  }

  // ─── tabla ─────────────────────────────────────────────────────────────

  /** Existencia mínima efectiva: la casilla "solo con existencia" vale por un 1. */
  function existenciaMinima() {
    var valor = parseInt($("#min-existencia").value, 10);
    if (!isFinite(valor) || valor < 0) valor = 0;
    return Math.max(valor, $("#opt-stock").checked ? 1 : 0);
  }

  /** Compara referencias con los números en orden natural (A2 antes que A10).
      Las variantes sin referencia se van siempre al final. */
  function compararSku(a, b, descendente) {
    var vacioA = !a.sku, vacioB = !b.sku;
    if (vacioA !== vacioB) return vacioA ? 1 : -1;
    if (vacioA) return a.titulo.localeCompare(b.titulo, "es");
    var diferencia = String(a.sku).localeCompare(String(b.sku), "es",
      { numeric: true, sensitivity: "base" });
    if (descendente) diferencia = -diferencia;
    return diferencia || a.titulo.localeCompare(b.titulo, "es");
  }

  function enLista() {
    var items = estado.productos.slice();
    var minimo = existenciaMinima();
    if (minimo > 0) {
      // "sin control" de inventario no se filtra: no tiene existencia que medir.
      items = items.filter(function (item) {
        return item.existencia === null || item.existencia >= minimo;
      });
    }
    var orden = $("#orden").value;
    var precio = function (item) {
      var valor = DOCUMENTOS.precioDe(item, estado.lista).valor;
      return valor === null ? Number.MAX_SAFE_INTEGER : valor;
    };
    if (orden === "referencia") items.sort(function (a, b) { return compararSku(a, b, false); });
    if (orden === "referencia-desc") items.sort(function (a, b) { return compararSku(a, b, true); });
    if (orden === "nombre") items.sort(function (a, b) { return a.titulo.localeCompare(b.titulo, "es"); });
    if (orden === "precio") items.sort(function (a, b) { return precio(a) - precio(b); });
    if (orden === "precio-desc") items.sort(function (a, b) { return precio(b) - precio(a); });
    if (orden === "existencia") items.sort(function (a, b) { return (b.existencia || 0) - (a.existencia || 0); });
    return items;
  }

  function elegidos() {
    return enLista().filter(function (item) { return !estado.fuera[item.id]; });
  }

  function pintar() {
    var filas = enLista();
    var aguja = normalizar(estado.filtro);
    var visibles = aguja ? filas.filter(function (item) {
      return normalizar(item.titulo).indexOf(aguja) >= 0 || normalizar(item.sku).indexOf(aguja) >= 0;
    }) : filas;

    var cuerpo = $("#filas");
    cuerpo.innerHTML = "";
    visibles.forEach(function (item) {
      var precio = DOCUMENTOS.precioDe(item, estado.lista);
      var fila = document.createElement("tr");
      fila.innerHTML = '<td class="col-check"><input type="checkbox"></td>' +
        '<td class="col-thumb"></td><td class="sku-cell"></td><td class="title-cell"></td>' +
        '<td class="col-price"><b></b><em></em></td><td class="col-count"></td>';

      var casilla = fila.querySelector("input");
      casilla.checked = !estado.fuera[item.id];
      fila.classList.toggle("is-off", !casilla.checked);
      casilla.addEventListener("change", function () {
        if (casilla.checked) delete estado.fuera[item.id];
        else estado.fuera[item.id] = true;
        fila.classList.toggle("is-off", !casilla.checked);
        actualizarBarra();
      });

      var celdaFoto = fila.querySelector(".col-thumb");
      if (item.imagen) {
        var foto = document.createElement("img");
        foto.className = "thumb";
        foto.loading = "lazy";
        foto.alt = "";
        foto.src = item.imagen.replace(/(\?|&)width=\d+/, "$1width=90");
        celdaFoto.appendChild(foto);
      } else {
        var hueco = document.createElement("div");
        hueco.className = "thumb thumb-empty";
        hueco.textContent = "—";
        celdaFoto.appendChild(hueco);
      }

      fila.querySelector(".sku-cell").textContent = item.sku || "—";
      fila.querySelector(".title-cell").textContent = item.titulo;
      fila.querySelector(".col-price b").textContent = DOCUMENTOS.dinero(precio.valor);
      fila.querySelector(".col-price em").textContent = precio.aproximado ? "precio normal" : "";
      var existencia = fila.querySelector(".col-count");
      existencia.textContent = item.existencia === null ? "sin control"
        : (item.existencia > 0 ? item.existencia : "0");
      if (!(item.existencia > 0)) existencia.classList.add("mute-cell");
      cuerpo.appendChild(fila);
    });

    $("#sin-filas").classList.toggle("hidden", visibles.length > 0);
    $("#th-precio").textContent = DOCUMENTOS.etiquetaLista(estado.lista);
    var todas = filas.length > 0 && filas.every(function (item) { return !estado.fuera[item.id]; });
    $("#todos").checked = todas;
    $("#alternar").textContent = todas ? "Quitar todos" : "Incluir todos";
    actualizarBarra();
  }

  function actualizarBarra() {
    var items = elegidos();
    $("#barra").classList.toggle("hidden", !estado.productos.length);
    $("#seleccion").textContent = items.length + " producto" + (items.length === 1 ? "" : "s");
    var empresa = $("#empresa").value.trim();
    $("#detalle").textContent = ($("#opt-sinprecio").checked ? "Sin precios" : DOCUMENTOS.etiquetaLista(estado.lista)) +
      (empresa ? " · para " + empresa : "") + (estado.idioma === "en" ? " · English" : "");
    $("#btn-pdf").disabled = !items.length;
    $("#btn-excel").disabled = !items.length;

    $("#stat-total").textContent = items.length;
    $("#stat-stock").textContent = items.filter(function (i) {
      return i.existencia === null || i.existencia > 0;
    }).length;
    $("#stat-sinlista").textContent = items.filter(function (i) {
      return DOCUMENTOS.precioDe(i, estado.lista).aproximado;
    }).length;
    $("#stat-sinfoto").textContent = items.filter(function (i) { return !i.imagen; }).length;
  }

  // ─── progreso ──────────────────────────────────────────────────────────

  function mostrarProgreso(titulo, detalle) {
    $("#progreso-titulo").textContent = titulo;
    $("#progreso-detalle").textContent = detalle || "";
    $("#barra-relleno").style.width = "0%";
    $("#progreso").classList.remove("hidden");
  }

  function actualizarProgreso(hechas, total, detalle) {
    var porcentaje = total ? Math.round((hechas / total) * 100) : 0;
    $("#barra-relleno").style.width = Math.min(porcentaje, 100) + "%";
    if (detalle) $("#progreso-detalle").textContent = detalle;
  }

  function esconderProgreso() { $("#progreso").classList.add("hidden"); }

  // ─── descargas ─────────────────────────────────────────────────────────

  function opciones() {
    return {
      lista: estado.lista,
      idioma: estado.idioma,
      empresa: $("#empresa").value.trim(),
      nota: $("#nota").value.trim(),
      tienda: config.tienda || "Sirena Internacional",
      web: config.web || "",
      existencia: $("#opt-existencia").checked,
      enlace: $("#opt-enlace").checked,
      cantidad: $("#opt-cantidad").checked,
      fotos: $("#opt-fotos").checked,
      sinPrecio: $("#opt-sinprecio").checked
    };
  }

  async function generar(formato, boton) {
    var items = elegidos();
    if (!items.length) { aviso("Selecciona al menos un producto.", "error"); return; }
    var conFotos = formato === "pdf" || $("#opt-fotos").checked;

    ocupado(boton, true);
    mostrarProgreso("Preparando el catálogo", conFotos ? "Descargando fotos…" : "Armando el archivo…");
    try {
      var fotos = {};
      if (conFotos) {
        var ancho = formato === "pdf" ? anchoFoto(items.length) : 200;
        fotos = await DOCUMENTOS.bajarFotos(
          items.map(function (item) { return item.imagen; }),
          ancho, CALIDAD,
          function (hechas, total) {
            actualizarProgreso(hechas, total, "Fotos " + hechas + " de " + total);
          },
          DESCARGAS_A_LA_VEZ
        );
      }
      actualizarProgreso(1, 1, "Armando el archivo…");
      await new Promise(function (listo) { setTimeout(listo, 30); });

      var datos = {
        titulo: estado.tituloDocumento || estado.coleccion.titulo,
        handle: estado.coleccion.handle,
        productos: items
      };
      var sinFoto = items.filter(function (item) { return !fotos[item.imagen]; }).length;

      if (formato === "pdf") {
        descargar(nombreArchivo(".pdf"), DOCUMENTOS.construirPdf(datos, opciones(), fotos),
          "application/pdf");
      } else {
        descargar(nombreArchivo(".xlsx"), DOCUMENTOS.construirExcel(datos, opciones(), fotos),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      }
      aviso(sinFoto
        ? "Listo: " + items.length + " productos (" + sinFoto + " sin foto)."
        : "Listo: " + items.length + " productos.", sinFoto ? "info" : "ok", 6000);
    } catch (error) {
      aviso("No se pudo generar el archivo: " + (error && error.message || error), "error", 9000);
    } finally {
      esconderProgreso();
      ocupado(boton, false);
    }
  }

  // ─── eventos ───────────────────────────────────────────────────────────

  function arrancar() {
    if (config.sesion && config.nombre) {
      $("#sesion").innerHTML = "";
      var saludo = document.createElement("span");
      saludo.textContent = "Sesión de ";
      var nombre = document.createElement("b");
      nombre.textContent = config.nombre;
      $("#sesion").appendChild(saludo);
      $("#sesion").appendChild(nombre);
    } else if (!config.sesion) {
      var enlace = document.createElement("a");
      enlace.href = "/account/login";
      enlace.textContent = "Iniciar sesión para ver las listas";
      $("#sesion").appendChild(enlace);
    }
    pintarListas();
    pintarColecciones();
  }

  $$("#idiomas .segment-btn").forEach(function (boton) {
    boton.addEventListener("click", function () { cambiarIdioma(boton.dataset.idioma); });
  });
  $("#limpiar-colecciones").addEventListener("click", function () {
    var antes = estado.colecciones.slice();
    estado.colecciones = [];
    aplicarColecciones(antes, false);
  });
  $("#buscar-coleccion").addEventListener("input", function (evento) {
    estado.busqueda = evento.target.value;
    pintarColecciones();
  });
  $("#filtro").addEventListener("input", function (evento) {
    estado.filtro = evento.target.value;
    pintar();
  });
  $("#todos").addEventListener("change", function (evento) {
    if (evento.target.checked) estado.fuera = {};
    else enLista().forEach(function (item) { estado.fuera[item.id] = true; });
    pintar();
  });
  $("#alternar").addEventListener("click", function () {
    var filas = enLista();
    var todas = filas.length > 0 && filas.every(function (item) { return !estado.fuera[item.id]; });
    if (todas) filas.forEach(function (item) { estado.fuera[item.handle] = true; });
    else estado.fuera = {};
    pintar();
  });
  ["#opt-stock", "#orden", "#min-existencia"].forEach(function (id) {
    $(id).addEventListener("change", pintar);
  });
  $("#min-existencia").addEventListener("input", pintar);
  $("#empresa").addEventListener("input", actualizarBarra);
  $("#opt-sinprecio").addEventListener("change", actualizarBarra);
  $("#btn-pdf").addEventListener("click", function (evento) {
    generar("pdf", evento.currentTarget);
  });
  $("#btn-excel").addEventListener("click", function (evento) {
    generar("excel", evento.currentTarget);
  });

  if (pedirAcceso()) arrancar();
})();
